import { Injectable, inject } from "@angular/core";
import * as ExcelJS from 'exceljs';
import { NumberService } from "./number.service";
import { SysUtilService } from "./sysUtil.service";
import { env } from "../../../app.constant";

@Injectable()
export class ExcelConsolidatedSABAUDB {

    private numService: NumberService = inject(NumberService);
    private sysUtil: SysUtilService = inject(SysUtilService);

    private numberFormat = "#,##0.00";
    private fontStyle = {
        header: { name: 'Times New Roman', size: 10, bold: true },
        content: { name: 'Times New Roman', size: 10 }
    };
    private borderStyle: any = {
        thin: { style: 'thin' },
        full: {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' }
        },
        topBottom: {
            top: { style: 'thin' },
            bottom: { style: 'thin' }
        },
        leftRight: {
            left: { style: 'thin' },
            right: { style: 'thin' }
        },
        topLeft: {
            top: { style: 'thin' },
            left: { style: 'thin' }
        },
        topRight: {
            top: { style: 'thin' },
            left: { style: 'thin' }
        },
        bottomLeft: {
            bottom: { style: 'thin' },
            left: { style: 'thin' }
        },
        bottomRight: {
            bottom: { style: 'thin' },
            right: { style: 'thin' }
        }
    };
    private startPosition = 13;
    private columns = [
        'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z',
        'AA', 'AB', 'AC', 'AD', 'AE', 'AF', 'AG', 'AH', 'AI', 'AJ', 'AK', 'AL', 'AM', 'AN', 'AO', 'AP', 'AQ', 'AR', 'AS', 'AT', 'AU', 'AV', 'AW', 'AX', 'AY', 'AZ',
        'BA', 'BB', 'BC', 'BD', 'BE', 'BF', 'BG', 'BH', 'BI', 'BJ', 'BK', 'BL', 'BM', 'BN', 'BO', 'BP', 'BQ', 'BR', 'BS', 'BT', 'BU', 'BV', 'BW', 'BX', 'BY', 'BZ',
        'CA'
    ];

    private detailed_columns = [
        "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z",
        "AA", "AB", "AC", "AD", "AE", "AF", "AG", "AH", "AI", "AJ", "AK", "AL", "AM", "AN", "AO", "AP", "AQ", "AR", "AS", "AT", "AU", "AV", "AW", "AX", "AY", "AZ",
        "BA", "BB", "BC", "BD", "BE", "BF", "BG", "BH", "BI", "BJ", "BK", "BL", "BM", "BN", "BO", "BP", "BQ", "BR", "BS", "BT", "BU", "BV", "BW", "BX", "BY", "BZ",
        "CA", "CB", "CC", "CD", "CE", "CF", "CG", "CH", "CI", "CJ", "CK", "CL", "CM", "CN", "CO", "CP", "CQ", "CR", "CS", "CT", "CU", "CV", "CW", "CX", "CY", "CZ",
        "DA", "DB", "DC", "DD", "DE", "DF", "DG", "DH", "DI", "DJ", "DK", "DL", "DM", "DN", "DO", "DP", "DQ", "DR", "DS", "DT", "DU", "DV", "DW", "DX", "DY", "DZ",
        "EA", "EB", "EC", "ED", "EE", "EF", "EG", "EH", "EI", "EJ", "EK", "EL", "EM", "EN", "EO", "EP", "EQ", "ER", "ES", "ET", "EU", "EV", "EW", "EX", "EY", "EZ",
        "FA", "FB", "FC", "FD", "FE", "FF", "FG", "FH", "FI", "FJ", "FK", "FL", "FM", "FN", "FO", "FP", "FQ", "FR", "FS", "FT", "FU", "FV", "FW", "FX", "FY", "FZ",
        "GA", "GB", "GC", "GD", "GE", "GF", "GG", "GH", "GI", "GJ", "GK", "GL", "GM", "GN", "GO", "GP", "GQ", "GR", "GS", "GT", "GU", "GV", "GW", "GX", "GY", "GZ",
        "HA", "HB", "HC", "HD", "HE", "HF", "HG", "HH", "HI", "HJ", "HK", "HL", "HM", "HN", "HO", "HP", "HQ", "HR", "HS", "HT", "HU", "HV", "HW", "HX", "HY", "HZ",
        "IA", "IB", "IC", "ID", "IE", "IF", "IG", "IH", "II", "IJ", "IK", "IL", "IM", "IN", "IO", "IP", "IQ", "IR", "IS", "IT"
    ];

    private summary_columns = [
        "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z",
        "AA", "AB", "AC", "AD", "AE", "AF", "AG", "AH", "AI", "AJ", "AK", "AL",
    ];

    private romanNumber: Array<string> = ['I', 'II'];
    private romanIndex: string = "";
    private fundSourceIndex: string = "";
    private aIndex: number = 0;
    private bIndex: number = 1;
    private cIndex: number = 0;

    async generatePRE(data: Array<any>, campus: number, options: any = { fileName: "Consolidated_SABAUDB_PRE", sheetName: "PRE" }) {
        const wb = new ExcelJS.Workbook();
        wb.addWorksheet(options.sheetName);

        const ws = wb.getWorksheet(options.sheetName);

        const imagePath = './assets/BatStateULogo.png';

        this.sysUtil.getBase64ImageFromUrl(imagePath).then(async (result: any) => {

            let imageId = wb.addImage({ base64: result, extension: 'png' });
            ws.addImage(imageId, { tl: { col: 35, row: 2 }, ext: { width: 120, height: 110 } });

            ws.columns = [
                { header: "", key: "part", width: 48 },
                { header: "", key: "uacs", width: 16 },
                { header: "", key: "ap_c", width: 16 },
                { header: "", key: "ap_p", width: 16 },
                { header: "", key: "ap_a", width: 16 },
                { header: "", key: "ap_l", width: 16 },
                { header: "", key: "ap_m", width: 16 },
                { header: "", key: "ap_n", width: 16 },
                { header: "", key: "ttl_ap", width: 16 },
                { header: "", key: "ap_adjm_c", width: 16 },
                { header: "", key: "ap_adjm_p", width: 16 },
                { header: "", key: "ap_adjm_a", width: 16 },
                { header: "", key: "ap_adjm_l", width: 16 },
                { header: "", key: "ap_adjm_m", width: 16 },
                { header: "", key: "ap_adjm_n", width: 16 },
                { header: "", key: "ttl_ap_adjm", width: 16 },
                { header: "", key: "ap_adjd_c", width: 16 },
                { header: "", key: "ap_adjd_p", width: 16 },
                { header: "", key: "ap_adjd_a", width: 16 },
                { header: "", key: "ap_adjd_l", width: 16 },
                { header: "", key: "ap_adjd_m", width: 16 },
                { header: "", key: "ap_adjd_n", width: 16 },
                { header: "", key: "ttl_ap_adjd", width: 16 },
                { header: "", key: "al_c", width: 16 },
                { header: "", key: "al_p", width: 16 },
                { header: "", key: "al_a", width: 16 },
                { header: "", key: "al_l", width: 16 },
                { header: "", key: "al_m", width: 16 },
                { header: "", key: "al_n", width: 16 },
                { header: "", key: "ttl_al", width: 16 },
                { header: "", key: "al_adjm_c", width: 16 },
                { header: "", key: "al_adjm_p", width: 16 },
                { header: "", key: "al_adjm_a", width: 16 },
                { header: "", key: "al_adjm_l", width: 16 },
                { header: "", key: "al_adjm_m", width: 16 },
                { header: "", key: "al_adjm_n", width: 16 },
                { header: "", key: "ttl_al_adjm", width: 16 },
                { header: "", key: "al_adjd_c", width: 16 },
                { header: "", key: "al_adjd_p", width: 16 },
                { header: "", key: "al_adjd_a", width: 16 },
                { header: "", key: "al_adjd_l", width: 16 },
                { header: "", key: "al_adjd_m", width: 16 },
                { header: "", key: "al_adjd_n", width: 16 },
                { header: "", key: "ttl_al_adjd", width: 16 },
                { header: "", key: "ut_c", width: 16 },
                { header: "", key: "ut_p", width: 16 },
                { header: "", key: "ut_a", width: 16 },
                { header: "", key: "ut_l", width: 16 },
                { header: "", key: "ut_m", width: 16 },
                { header: "", key: "ut_n", width: 16 },
                { header: "", key: "ttl_ut", width: 16 },
                { header: "", key: "un_al_c", width: 16 },
                { header: "", key: "un_al_p", width: 16 },
                { header: "", key: "un_al_a", width: 16 },
                { header: "", key: "un_al_l", width: 16 },
                { header: "", key: "un_al_m", width: 16 },
                { header: "", key: "un_al_n", width: 16 },
                { header: "", key: "ttl_un_al", width: 16 },
                { header: "", key: "d_c", width: 16 },
                { header: "", key: "d_p", width: 16 },
                { header: "", key: "d_a", width: 16 },
                { header: "", key: "d_l", width: 16 },
                { header: "", key: "d_m", width: 16 },
                { header: "", key: "d_n", width: 16 },
                { header: "", key: "ttl_d", width: 16 },
                { header: "", key: "dnd_c", width: 16 },
                { header: "", key: "dnd_p", width: 16 },
                { header: "", key: "dnd_a", width: 16 },
                { header: "", key: "dnd_l", width: 16 },
                { header: "", key: "dnd_m", width: 16 },
                { header: "", key: "dnd_n", width: 16 },
                { header: "", key: "ttl_dnd", width: 16 },
                { header: "", key: "nydnd_c", width: 16 },
                { header: "", key: "nydnd_p", width: 16 },
                { header: "", key: "nydnd_a", width: 16 },
                { header: "", key: "nydnd_l", width: 16 },
                { header: "", key: "nydnd_m", width: 16 },
                { header: "", key: "nydnd_n", width: 16 },
                { header: "", key: "ttl_nydnd", width: 16 }
            ];

            console.log(`ExcelConsolidatedSABAUDB->generatePRE()->data`, data);

            this.setDocumentHeader(ws, campus);

            this.setPREHeader(ws);

            const exclude_particulars = ['sub-total', 'total', 'grand total'];
            const exclude_uacs_pattern = ["0000000", "9999999"];

            data.forEach((d: any, i: number) => {

                ws.addRow({
                    part: `${this.getNumber(d)}${d.part}`,
                    uacs: (d.ac == null || d.ac == "99" || d.ac == "98" || d.uacs == null || d.uacs == "0000000000" || exclude_particulars.includes(d.part.toLowerCase())) ? "" : d.uacs,
                    ap_c: this.numService.isNumber(d.ap_c) ? Number(d.ap_c) : "",
                    ap_p: this.numService.isNumber(d.ap_p) ? Number(d.ap_p) : "",
                    ap_n: this.numService.isNumber(d.ap_n) ? Number(d.ap_n) : "",
                    ap_m: this.numService.isNumber(d.ap_m) ? Number(d.ap_m) : "",
                    ap_a: this.numService.isNumber(d.ap_a) ? Number(d.ap_a) : "",
                    ap_l: this.numService.isNumber(d.ap_l) ? Number(d.ap_l) : "",
                    ttl_ap: this.numService.isNumber(d.ttl_ap) ? Number(d.ttl_ap) : "",
                    ap_adjm_c: this.numService.isNumber(d.ap_adjm_c) ? Number(d.ap_adjm_c) : "",
                    ap_adjm_p: this.numService.isNumber(d.ap_adjm_p) ? Number(d.ap_adjm_p) : "",
                    ap_adjm_n: this.numService.isNumber(d.ap_adjm_n) ? Number(d.ap_adjm_n) : "",
                    ap_adjm_m: this.numService.isNumber(d.ap_adjm_m) ? Number(d.ap_adjm_m) : "",
                    ap_adjm_a: this.numService.isNumber(d.ap_adjm_a) ? Number(d.ap_adjm_a) : "",
                    ap_adjm_l: this.numService.isNumber(d.ap_adjm_l) ? Number(d.ap_adjm_l) : "",
                    ttl_ap_adjm: this.numService.isNumber(d.ttl_ap_adjm) ? Number(d.ttl_ap_adjm) : "",
                    ap_adjd_c: this.numService.isNumber(d.ap_adjd_c) ? Number(d.ap_adjd_c) : "",
                    ap_adjd_p: this.numService.isNumber(d.ap_adjd_p) ? Number(d.ap_adjd_p) : "",
                    ap_adjd_n: this.numService.isNumber(d.ap_adjd_n) ? Number(d.ap_adjd_n) : "",
                    ap_adjd_m: this.numService.isNumber(d.ap_adjd_m) ? Number(d.ap_adjd_m) : "",
                    ap_adjd_a: this.numService.isNumber(d.ap_adjd_a) ? Number(d.ap_adjd_a) : "",
                    ap_adjd_l: this.numService.isNumber(d.ap_adjd_l) ? Number(d.ap_adjd_l) : "",
                    ttl_ap_adjd: this.numService.isNumber(d.ttl_ap_adjd) ? Number(d.ttl_ap_adjd) : "",
                    al_c: this.numService.isNumber(d.al_c) ? Number(d.al_c) : "",
                    al_p: this.numService.isNumber(d.al_p) ? Number(d.al_p) : "",
                    al_n: this.numService.isNumber(d.al_n) ? Number(d.al_n) : "",
                    al_m: this.numService.isNumber(d.al_m) ? Number(d.al_m) : "",
                    al_a: this.numService.isNumber(d.al_a) ? Number(d.al_a) : "",
                    al_l: this.numService.isNumber(d.al_l) ? Number(d.al_l) : "",
                    ttl_al: this.numService.isNumber(d.ttl_al) ? Number(d.ttl_al) : "",
                    al_adjm_c: this.numService.isNumber(d.al_adjm_c) ? Number(d.al_adjm_c) : "",
                    al_adjm_p: this.numService.isNumber(d.al_adjm_p) ? Number(d.al_adjm_p) : "",
                    al_adjm_n: this.numService.isNumber(d.al_adjm_n) ? Number(d.al_adjm_n) : "",
                    al_adjm_m: this.numService.isNumber(d.al_adjm_m) ? Number(d.al_adjm_m) : "",
                    al_adjm_a: this.numService.isNumber(d.al_adjm_a) ? Number(d.al_adjm_a) : "",
                    al_adjm_l: this.numService.isNumber(d.al_adjm_l) ? Number(d.al_adjm_l) : "",
                    ttl_al_adjm: this.numService.isNumber(d.ttl_al_adjm) ? Number(d.ttl_al_adjm) : "",
                    al_adjd_c: this.numService.isNumber(d.al_adjd_c) ? Number(d.al_adjd_c) : "",
                    al_adjd_p: this.numService.isNumber(d.al_adjd_p) ? Number(d.al_adjd_p) : "",
                    al_adjd_n: this.numService.isNumber(d.al_adjd_n) ? Number(d.al_adjd_n) : "",
                    al_adjd_m: this.numService.isNumber(d.al_adjd_m) ? Number(d.al_adjd_m) : "",
                    al_adjd_a: this.numService.isNumber(d.al_adjd_a) ? Number(d.al_adjd_a) : "",
                    al_adjd_l: this.numService.isNumber(d.al_adjd_l) ? Number(d.al_adjd_l) : "",
                    ttl_al_adjd: this.numService.isNumber(d.ttl_al_adjd) ? Number(d.ttl_al_adjd) : "",
                    ut_c: this.numService.isNumber(d.ut_c) ? Number(d.ut_c) : "",
                    ut_p: this.numService.isNumber(d.ut_p) ? Number(d.ut_p) : "",
                    ut_n: this.numService.isNumber(d.ut_n) ? Number(d.ut_n) : "",
                    ut_m: this.numService.isNumber(d.ut_m) ? Number(d.ut_m) : "",
                    ut_a: this.numService.isNumber(d.ut_a) ? Number(d.ut_a) : "",
                    ut_l: this.numService.isNumber(d.ut_l) ? Number(d.ut_l) : "",
                    ttl_ut: this.numService.isNumber(d.ttl_ut) ? Number(d.ttl_ut) : "",
                    un_al_c: this.numService.isNumber(d.un_al_c) ? Number(d.un_al_c) : "",
                    un_al_p: this.numService.isNumber(d.un_al_p) ? Number(d.un_al_p) : "",
                    un_al_n: this.numService.isNumber(d.un_al_n) ? Number(d.un_al_n) : "",
                    un_al_m: this.numService.isNumber(d.un_al_m) ? Number(d.un_al_m) : "",
                    un_al_a: this.numService.isNumber(d.un_al_a) ? Number(d.un_al_a) : "",
                    un_al_l: this.numService.isNumber(d.un_al_l) ? Number(d.un_al_l) : "",
                    ttl_un_al: this.numService.isNumber(d.ttl_un_al) ? Number(d.ttl_un_al) : "",
                    d_c: this.numService.isNumber(d.d_c) ? Number(d.d_c) : "",
                    d_p: this.numService.isNumber(d.d_p) ? Number(d.d_p) : "",
                    d_n: this.numService.isNumber(d.d_n) ? Number(d.d_n) : "",
                    d_m: this.numService.isNumber(d.d_m) ? Number(d.d_m) : "",
                    d_a: this.numService.isNumber(d.d_a) ? Number(d.d_a) : "",
                    d_l: this.numService.isNumber(d.d_l) ? Number(d.d_l) : "",
                    ttl_d: this.numService.isNumber(d.ttl_d) ? Number(d.ttl_d) : "",
                    dnd_c: this.numService.isNumber(d.pybl_c) ? Number(d.pybl_c) - Number(d.d_c) : "",
                    dnd_p: this.numService.isNumber(d.pybl_p) ? Number(d.pybl_p) - Number(d.d_p) : "",
                    dnd_n: this.numService.isNumber(d.pybl_n) ? Number(d.pybl_n) - Number(d.d_n) : "",
                    dnd_m: this.numService.isNumber(d.pybl_m) ? Number(d.pybl_m) - Number(d.d_m) : "",
                    dnd_a: this.numService.isNumber(d.pybl_a) ? Number(d.pybl_a) - Number(d.d_a) : "",
                    dnd_l: this.numService.isNumber(d.pybl_l) ? Number(d.pybl_l) - Number(d.d_l) : "",
                    ttl_dnd: this.numService.isNumber(d.ttl_pybl) ? Number(d.ttl_pybl) - Number(d.ttl_d) : "",
                    nydnd_c: this.numService.isNumber(d.ut_c) ? Number(d.ut_c) - Number(d.pybl_c) : "",
                    nydnd_p: this.numService.isNumber(d.ut_p) ? Number(d.ut_p) - Number(d.pybl_p) : "",
                    nydnd_n: this.numService.isNumber(d.ut_n) ? Number(d.ut_n) - Number(d.pybl_n) : "",
                    nydnd_m: this.numService.isNumber(d.ut_m) ? Number(d.ut_m) - Number(d.pybl_m) : "",
                    nydnd_a: this.numService.isNumber(d.ut_a) ? Number(d.ut_a) - Number(d.pybl_a) : "",
                    nydnd_l: this.numService.isNumber(d.ut_l) ? Number(d.ut_l) - Number(d.pybl_l) : "",
                    ttl_nydnd: this.numService.isNumber(d.ttl_ut) ? Number(d.ttl_ut) - Number(d.ttl_pybl) : ""
                });

                this.columns.forEach((col: string, index: number) => {
                    let cell = ws.getCell(`${col}${(this.startPosition + 3) + i}`);
                    if (index >= 2) {
                        cell.style = { numFmt: this.numberFormat };
                    }
                    if (d.uacs == null || d.ac == null || exclude_uacs_pattern.includes(d.uacs.substring(3))) {
                        cell.font = this.fontStyle.header;
                    } else {
                        cell.font = this.fontStyle.content;
                    }
                    cell.border = this.borderStyle.full;
                    cell.alignment = {
                        wrapText: true,
                        vertical: 'middle',
                        horizontal: (col == 'A') ? 'left' : 'right',
                        indent: (col == 'A' && this.indention(d)) ? 2 : 0
                    };
                });
            });

            // ws.getRow(1).height = 60;

            const arrayData = await wb.xlsx.writeBuffer();
            const blob = new Blob([arrayData], { type: "application/octet-binary" });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `${options.fileName}.xlsx`;
            a.click();
            a.remove();
        });


    }

    async generateDetailed(data: Array<any>, campus: number, options: any = { fileName: "Consolidated_SABAUDB_Detailed", sheetName: "Detailed" }) {
        const wb = new ExcelJS.Workbook();
        wb.addWorksheet(options.sheetName);

        const ws = wb.getWorksheet(options.sheetName);

        const imagePath = './assets/BatStateULogo.png';

        this.sysUtil.getBase64ImageFromUrl(imagePath).then(async (result: any) => {

            let imageId = wb.addImage({ base64: result, extension: 'png' });
            ws.addImage(imageId, { tl: { col: 35, row: 2 }, ext: { width: 120, height: 110 } });

            ws.columns = [
                { header: "", key: "part", width: 48 },
                { header: "", key: "uacs", width: 16 },
                { header: "", key: "ap_c", width: 16 },
                { header: "", key: "ap_p", width: 16 },
                { header: "", key: "ap_a", width: 16 },
                { header: "", key: "ap_l", width: 16 },
                { header: "", key: "ap_m", width: 16 },
                { header: "", key: "ap_n", width: 16 },
                { header: "", key: "ttl_ap", width: 16 },
                { header: "", key: "sb_ap_c", width: 16 },
                { header: "", key: "sb_ap_p", width: 16 },
                { header: "", key: "sb_ap_a", width: 16 },
                { header: "", key: "sb_ap_l", width: 16 },
                { header: "", key: "sb_ap_m", width: 16 },
                { header: "", key: "sb_ap_n", width: 16 },
                { header: "", key: "sb_ttl_ap", width: 16 },
                { header: "", key: "total_ap_c", width: 16 },
                { header: "", key: "total_ap_p", width: 16 },
                { header: "", key: "total_ap_a", width: 16 },
                { header: "", key: "total_ap_l", width: 16 },
                { header: "", key: "total_ap_m", width: 16 },
                { header: "", key: "total_ap_n", width: 16 },
                { header: "", key: "total_ap", width: 16 },

                { header: "", key: "ap_adjm_c", width: 16 },
                { header: "", key: "ap_adjm_p", width: 16 },
                { header: "", key: "ap_adjm_a", width: 16 },
                { header: "", key: "ap_adjm_l", width: 16 },
                { header: "", key: "ap_adjm_m", width: 16 },
                { header: "", key: "ap_adjm_n", width: 16 },
                { header: "", key: "ttl_ap_adjm", width: 16 },
                { header: "", key: "sb_ap_adjm_c", width: 16 },
                { header: "", key: "sb_ap_adjm_p", width: 16 },
                { header: "", key: "sb_ap_adjm_a", width: 16 },
                { header: "", key: "sb_ap_adjm_l", width: 16 },
                { header: "", key: "sb_ap_adjm_m", width: 16 },
                { header: "", key: "sb_ap_adjm_n", width: 16 },
                { header: "", key: "sb_ttl_ap_adjm", width: 16 },
                { header: "", key: "total_ap_adjm_c", width: 16 },
                { header: "", key: "total_ap_adjm_p", width: 16 },
                { header: "", key: "total_ap_adjm_a", width: 16 },
                { header: "", key: "total_ap_adjm_l", width: 16 },
                { header: "", key: "total_ap_adjm_m", width: 16 },
                { header: "", key: "total_ap_adjm_n", width: 16 },
                { header: "", key: "total_ap_adjm", width: 16 },

                { header: "", key: "ap_adjd_c", width: 16 },
                { header: "", key: "ap_adjd_p", width: 16 },
                { header: "", key: "ap_adjd_a", width: 16 },
                { header: "", key: "ap_adjd_l", width: 16 },
                { header: "", key: "ap_adjd_m", width: 16 },
                { header: "", key: "ap_adjd_n", width: 16 },
                { header: "", key: "ttl_ap_adjd", width: 16 },
                { header: "", key: "sb_ap_adjd_c", width: 16 },
                { header: "", key: "sb_ap_adjd_p", width: 16 },
                { header: "", key: "sb_ap_adjd_a", width: 16 },
                { header: "", key: "sb_ap_adjd_l", width: 16 },
                { header: "", key: "sb_ap_adjd_m", width: 16 },
                { header: "", key: "sb_ap_adjd_n", width: 16 },
                { header: "", key: "sb_ttl_ap_adjd", width: 16 },
                { header: "", key: "total_ap_adjd_c", width: 16 },
                { header: "", key: "total_ap_adjd_p", width: 16 },
                { header: "", key: "total_ap_adjd_a", width: 16 },
                { header: "", key: "total_ap_adjd_l", width: 16 },
                { header: "", key: "total_ap_adjd_m", width: 16 },
                { header: "", key: "total_ap_adjd_n", width: 16 },
                { header: "", key: "total_ap_adjd", width: 16 },

                { header: "", key: "al_c", width: 16 },
                { header: "", key: "al_p", width: 16 },
                { header: "", key: "al_a", width: 16 },
                { header: "", key: "al_l", width: 16 },
                { header: "", key: "al_m", width: 16 },
                { header: "", key: "al_n", width: 16 },
                { header: "", key: "ttl_al", width: 16 },
                { header: "", key: "sb_al_c", width: 16 },
                { header: "", key: "sb_al_p", width: 16 },
                { header: "", key: "sb_al_a", width: 16 },
                { header: "", key: "sb_al_l", width: 16 },
                { header: "", key: "sb_al_m", width: 16 },
                { header: "", key: "sb_al_n", width: 16 },
                { header: "", key: "sb_ttl_al", width: 16 },
                { header: "", key: "total_al_c", width: 16 },
                { header: "", key: "total_al_p", width: 16 },
                { header: "", key: "total_al_a", width: 16 },
                { header: "", key: "total_al_l", width: 16 },
                { header: "", key: "total_al_m", width: 16 },
                { header: "", key: "total_al_n", width: 16 },
                { header: "", key: "total_al", width: 16 },

                { header: "", key: "al_adjm_c", width: 16 },
                { header: "", key: "al_adjm_p", width: 16 },
                { header: "", key: "al_adjm_a", width: 16 },
                { header: "", key: "al_adjm_l", width: 16 },
                { header: "", key: "al_adjm_m", width: 16 },
                { header: "", key: "al_adjm_n", width: 16 },
                { header: "", key: "ttl_al_adjm", width: 16 },
                { header: "", key: "sb_al_adjm_c", width: 16 },
                { header: "", key: "sb_al_adjm_p", width: 16 },
                { header: "", key: "sb_al_adjm_a", width: 16 },
                { header: "", key: "sb_al_adjm_l", width: 16 },
                { header: "", key: "sb_al_adjm_m", width: 16 },
                { header: "", key: "sb_al_adjm_n", width: 16 },
                { header: "", key: "sb_ttl_al_adjm", width: 16 },
                { header: "", key: "total_al_adjm_c", width: 16 },
                { header: "", key: "total_al_adjm_p", width: 16 },
                { header: "", key: "total_al_adjm_a", width: 16 },
                { header: "", key: "total_al_adjm_l", width: 16 },
                { header: "", key: "total_al_adjm_m", width: 16 },
                { header: "", key: "total_al_adjm_n", width: 16 },
                { header: "", key: "total_al_adjm", width: 16 },

                { header: "", key: "al_adjd_c", width: 16 },
                { header: "", key: "al_adjd_p", width: 16 },
                { header: "", key: "al_adjd_a", width: 16 },
                { header: "", key: "al_adjd_l", width: 16 },
                { header: "", key: "al_adjd_m", width: 16 },
                { header: "", key: "al_adjd_n", width: 16 },
                { header: "", key: "ttl_al_adjd", width: 16 },
                { header: "", key: "sb_al_adjd_c", width: 16 },
                { header: "", key: "sb_al_adjd_p", width: 16 },
                { header: "", key: "sb_al_adjd_a", width: 16 },
                { header: "", key: "sb_al_adjd_l", width: 16 },
                { header: "", key: "sb_al_adjd_m", width: 16 },
                { header: "", key: "sb_al_adjd_n", width: 16 },
                { header: "", key: "sb_ttl_al_adjd", width: 16 },
                { header: "", key: "total_al_adjd_c", width: 16 },
                { header: "", key: "total_al_adjd_p", width: 16 },
                { header: "", key: "total_al_adjd_a", width: 16 },
                { header: "", key: "total_al_adjd_l", width: 16 },
                { header: "", key: "total_al_adjd_m", width: 16 },
                { header: "", key: "total_al_adjd_n", width: 16 },
                { header: "", key: "total_al_adjd", width: 16 },

                { header: "", key: "ut_c", width: 16 },
                { header: "", key: "ut_p", width: 16 },
                { header: "", key: "ut_a", width: 16 },
                { header: "", key: "ut_l", width: 16 },
                { header: "", key: "ut_m", width: 16 },
                { header: "", key: "ut_n", width: 16 },
                { header: "", key: "ttl_ut", width: 16 },
                { header: "", key: "sb_ut_c", width: 16 },
                { header: "", key: "sb_ut_p", width: 16 },
                { header: "", key: "sb_ut_a", width: 16 },
                { header: "", key: "sb_ut_l", width: 16 },
                { header: "", key: "sb_ut_m", width: 16 },
                { header: "", key: "sb_ut_n", width: 16 },
                { header: "", key: "sb_ttl_ut", width: 16 },
                { header: "", key: "total_ut_c", width: 16 },
                { header: "", key: "total_ut_p", width: 16 },
                { header: "", key: "total_ut_a", width: 16 },
                { header: "", key: "total_ut_l", width: 16 },
                { header: "", key: "total_ut_m", width: 16 },
                { header: "", key: "total_ut_n", width: 16 },
                { header: "", key: "total_ut", width: 16 },

                { header: "", key: "un_al_c", width: 16 },
                { header: "", key: "un_al_p", width: 16 },
                { header: "", key: "un_al_a", width: 16 },
                { header: "", key: "un_al_l", width: 16 },
                { header: "", key: "un_al_m", width: 16 },
                { header: "", key: "un_al_n", width: 16 },
                { header: "", key: "ttl_un_al", width: 16 },
                { header: "", key: "sb_un_al_c", width: 16 },
                { header: "", key: "sb_un_al_p", width: 16 },
                { header: "", key: "sb_un_al_a", width: 16 },
                { header: "", key: "sb_un_al_l", width: 16 },
                { header: "", key: "sb_un_al_m", width: 16 },
                { header: "", key: "sb_un_al_n", width: 16 },
                { header: "", key: "sb_ttl_un_al", width: 16 },
                { header: "", key: "total_un_al_c", width: 16 },
                { header: "", key: "total_un_al_p", width: 16 },
                { header: "", key: "total_un_al_a", width: 16 },
                { header: "", key: "total_un_al_l", width: 16 },
                { header: "", key: "total_un_al_m", width: 16 },
                { header: "", key: "total_un_al_n", width: 16 },
                { header: "", key: "total_un_al", width: 16 },

                { header: "", key: "un_ap_c", width: 16 },
                { header: "", key: "un_ap_p", width: 16 },
                { header: "", key: "un_ap_a", width: 16 },
                { header: "", key: "un_ap_l", width: 16 },
                { header: "", key: "un_ap_m", width: 16 },
                { header: "", key: "un_ap_n", width: 16 },
                { header: "", key: "ttl_un_ap", width: 16 },
                { header: "", key: "sb_un_ap_c", width: 16 },
                { header: "", key: "sb_un_ap_p", width: 16 },
                { header: "", key: "sb_un_ap_a", width: 16 },
                { header: "", key: "sb_un_ap_l", width: 16 },
                { header: "", key: "sb_un_ap_m", width: 16 },
                { header: "", key: "sb_un_ap_n", width: 16 },
                { header: "", key: "sb_ttl_un_ap", width: 16 },
                { header: "", key: "total_un_ap_c", width: 16 },
                { header: "", key: "total_un_ap_p", width: 16 },
                { header: "", key: "total_un_ap_a", width: 16 },
                { header: "", key: "total_un_ap_l", width: 16 },
                { header: "", key: "total_un_ap_m", width: 16 },
                { header: "", key: "total_un_ap_n", width: 16 },
                { header: "", key: "total_un_ap", width: 16 },

                { header: "", key: "d_c", width: 16 },
                { header: "", key: "d_p", width: 16 },
                { header: "", key: "d_a", width: 16 },
                { header: "", key: "d_l", width: 16 },
                { header: "", key: "d_m", width: 16 },
                { header: "", key: "d_n", width: 16 },
                { header: "", key: "ttl_d", width: 16 },
                { header: "", key: "sb_d_c", width: 16 },
                { header: "", key: "sb_d_p", width: 16 },
                { header: "", key: "sb_d_a", width: 16 },
                { header: "", key: "sb_d_l", width: 16 },
                { header: "", key: "sb_d_m", width: 16 },
                { header: "", key: "sb_d_n", width: 16 },
                { header: "", key: "sb_ttl_d", width: 16 },
                { header: "", key: "total_d_c", width: 16 },
                { header: "", key: "total_d_p", width: 16 },
                { header: "", key: "total_d_a", width: 16 },
                { header: "", key: "total_d_l", width: 16 },
                { header: "", key: "total_d_m", width: 16 },
                { header: "", key: "total_d_n", width: 16 },
                { header: "", key: "total_d", width: 16 },

                { header: "", key: "dnd_c", width: 16 },
                { header: "", key: "dnd_p", width: 16 },
                { header: "", key: "dnd_a", width: 16 },
                { header: "", key: "dnd_l", width: 16 },
                { header: "", key: "dnd_m", width: 16 },
                { header: "", key: "dnd_n", width: 16 },
                { header: "", key: "ttl_dnd", width: 16 },
                { header: "", key: "sb_dnd_c", width: 16 },
                { header: "", key: "sb_dnd_p", width: 16 },
                { header: "", key: "sb_dnd_a", width: 16 },
                { header: "", key: "sb_dnd_l", width: 16 },
                { header: "", key: "sb_dnd_m", width: 16 },
                { header: "", key: "sb_dnd_n", width: 16 },
                { header: "", key: "sb_ttl_dnd", width: 16 },
                { header: "", key: "total_dnd_c", width: 16 },
                { header: "", key: "total_dnd_p", width: 16 },
                { header: "", key: "total_dnd_a", width: 16 },
                { header: "", key: "total_dnd_l", width: 16 },
                { header: "", key: "total_dnd_m", width: 16 },
                { header: "", key: "total_dnd_n", width: 16 },
                { header: "", key: "total_dnd", width: 16 },

                { header: "", key: "nydnd_c", width: 16 },
                { header: "", key: "nydnd_p", width: 16 },
                { header: "", key: "nydnd_a", width: 16 },
                { header: "", key: "nydnd_l", width: 16 },
                { header: "", key: "nydnd_m", width: 16 },
                { header: "", key: "nydnd_n", width: 16 },
                { header: "", key: "ttl_nydnd", width: 16 },
                { header: "", key: "sb_nydnd_c", width: 16 },
                { header: "", key: "sb_nydnd_p", width: 16 },
                { header: "", key: "sb_nydnd_a", width: 16 },
                { header: "", key: "sb_nydnd_l", width: 16 },
                { header: "", key: "sb_nydnd_m", width: 16 },
                { header: "", key: "sb_nydnd_n", width: 16 },
                { header: "", key: "sb_ttl_nydnd", width: 16 },
                { header: "", key: "total_nydnd_c", width: 16 },
                { header: "", key: "total_nydnd_p", width: 16 },
                { header: "", key: "total_nydnd_a", width: 16 },
                { header: "", key: "total_nydnd_l", width: 16 },
                { header: "", key: "total_nydnd_m", width: 16 },
                { header: "", key: "total_nydnd_n", width: 16 },
                { header: "", key: "total_ttl_nydnd", width: 16 }
            ];

            console.log(`ExcelConsolidatedSABAUDB->generateDetailed()->data`, data);

            this.setDocumentHeader(ws, campus, "CA", true);

            this.setDetailedHeader(ws);

            const exclude_particulars = ['sub-total', 'total', 'grand total'];
            const exclude_uacs_pattern = ["0000000", "9999999"];

            data.forEach((d: any, i: number) => {

                let nydnd = [
                    // PRE
                    {
                        c: (Number(d.ut_c) - Number(d.d_c)) - (Number(d.ut_c) - Number(d.d_c)),
                        p: (Number(d.ut_p) - Number(d.d_p)) - (Number(d.ut_p) - Number(d.d_p)),
                        n: (Number(d.ut_n) - Number(d.d_n)) - (Number(d.ut_n) - Number(d.d_n)),
                        m: (Number(d.ut_m) - Number(d.d_m)) - (Number(d.ut_m) - Number(d.d_m)),
                        a: (Number(d.ut_a) - Number(d.d_a)) - (Number(d.ut_a) - Number(d.d_a)),
                        l: (Number(d.ut_l) - Number(d.d_l)) - (Number(d.ut_l) - Number(d.d_l)),
                        t: (Number(d.ttl_ut) - Number(d.ttl_d)) - (Number(d.ttl_ut) - Number(d.ttl_d)),
                    },
                    // SUPPLEMENTAL
                    {
                        c: (Number(d.sb_ut_c) - Number(d.sb_d_c)) - (Number(d.sb_ut_c) - Number(d.sb_d_c)),
                        p: (Number(d.sb_ut_p) - Number(d.sb_d_p)) - (Number(d.sb_ut_p) - Number(d.sb_d_p)),
                        n: (Number(d.sb_ut_n) - Number(d.sb_d_n)) - (Number(d.sb_ut_n) - Number(d.sb_d_n)),
                        m: (Number(d.sb_ut_m) - Number(d.sb_d_m)) - (Number(d.sb_ut_m) - Number(d.sb_d_m)),
                        a: (Number(d.sb_ut_a) - Number(d.sb_d_a)) - (Number(d.sb_ut_a) - Number(d.sb_d_a)),
                        l: (Number(d.sb_ut_l) - Number(d.sb_d_l)) - (Number(d.sb_ut_l) - Number(d.sb_d_l)),
                        t: (Number(d.sb_ttl_ut) - Number(d.sb_ttl_d)) - (Number(d.sb_ttl_ut) - Number(d.sb_ttl_d)),
                    }
                ];

                let unreleased_appr = [
                    {
                        c: this.coalesce(Number(d.ap_adjd_c) - Number(d.al_adjd_c), ""),
                        p: this.coalesce(Number(d.ap_adjd_p) - Number(d.al_adjd_p), ""),
                        n: this.coalesce(Number(d.ap_adjd_n) - Number(d.al_adjd_n), ""),
                        m: this.coalesce(Number(d.ap_adjd_m) - Number(d.al_adjd_m), ""),
                        a: this.coalesce(Number(d.ap_adjd_a) - Number(d.al_adjd_a), ""),
                        l: this.coalesce(Number(d.ap_adjd_l) - Number(d.al_adjd_l), ""),
                        t: this.coalesce(Number(d.ttl_ap_adjd) - Number(d.ttl_al_adjd), ""),
                    }, {
                        c: this.coalesce(Number(d.sb_ap_adjd_c) - Number(d.sb_al_adjd_c), ""),
                        p: this.coalesce(Number(d.sb_ap_adjd_p) - Number(d.sb_al_adjd_p), ""),
                        n: this.coalesce(Number(d.sb_ap_adjd_n) - Number(d.sb_al_adjd_n), ""),
                        m: this.coalesce(Number(d.sb_ap_adjd_m) - Number(d.sb_al_adjd_m), ""),
                        a: this.coalesce(Number(d.sb_ap_adjd_a) - Number(d.sb_al_adjd_a), ""),
                        l: this.coalesce(Number(d.sb_ap_adjd_l) - Number(d.sb_al_adjd_l), ""),
                        t: this.coalesce(Number(d.sb_ttl_ap_adjd) - Number(d.sb_ttl_al_adjd), ""),
                    }
                ];

                ws.addRow({
                    part: `${this.getNumber(d)}${d.part}`,
                    uacs: (d.ac == null || d.ac == "99" || d.ac == "98" || d.uacs == null || d.uacs == "0000000000" || exclude_particulars.includes(d.part.toLowerCase())) ? "" : d.uacs,
                    // appr
                    ap_c: this.coalesce(Number(d.ap_c), ""),
                    ap_p: this.coalesce(Number(d.ap_p), ""),
                    ap_a: this.coalesce(Number(d.ap_a), ""),
                    ap_n: this.coalesce(Number(d.ap_n), ""),
                    ap_m: this.coalesce(Number(d.ap_m), ""),
                    ap_l: this.coalesce(Number(d.ap_l), ""),
                    ttl_ap: this.coalesce(Number(d.ttl_ap), ""),
                    sb_ap_c: this.coalesce(Number(d.sb_ap_c), ""),
                    sb_ap_p: this.coalesce(Number(d.sb_ap_p), ""),
                    sb_ap_n: this.coalesce(Number(d.sb_ap_n), ""),
                    sb_ap_m: this.coalesce(Number(d.sb_ap_m), ""),
                    sb_ap_a: this.coalesce(Number(d.sb_ap_a), ""),
                    sb_ap_l: this.coalesce(Number(d.sb_ap_l), ""),
                    sb_ttl_ap: this.coalesce(Number(d.sb_ttl_ap), ""),
                    total_ap_c: this.coalesce(Number(d.ap_c) + Number(d.sb_ap_c), ""),
                    total_ap_p: this.coalesce(Number(d.ap_p) + Number(d.sb_ap_p), ""),
                    total_ap_n: this.coalesce(Number(d.ap_n) + Number(d.sb_ap_n), ""),
                    total_ap_m: this.coalesce(Number(d.ap_m) + Number(d.sb_ap_m), ""),
                    total_ap_a: this.coalesce(Number(d.ap_a) + Number(d.sb_ap_a), ""),
                    total_ap_l: this.coalesce(Number(d.ap_l) + Number(d.sb_ap_l), ""),
                    total_ap: this.coalesce(Number(d.ttl_ap) + Number(d.sb_ttl_ap), ""),

                    // appr adjustment
                    ap_adjm_c: this.coalesce(Number(d.ap_adjm_c), ""),
                    ap_adjm_p: this.coalesce(Number(d.ap_adjm_p), ""),
                    ap_adjm_n: this.coalesce(Number(d.ap_adjm_n), ""),
                    ap_adjm_m: this.coalesce(Number(d.ap_adjm_m), ""),
                    ap_adjm_a: this.coalesce(Number(d.ap_adjm_a), ""),
                    ap_adjm_l: this.coalesce(Number(d.ap_adjm_l), ""),
                    ttl_ap_adjm: this.coalesce(Number(d.ttl_ap_adjm), ""),
                    sb_ap_adjm_c: this.coalesce(Number(d.sb_ap_adjm_c), ""),
                    sb_ap_adjm_p: this.coalesce(Number(d.sb_ap_adjm_p), ""),
                    sb_ap_adjm_n: this.coalesce(Number(d.sb_ap_adjm_n), ""),
                    sb_ap_adjm_m: this.coalesce(Number(d.sb_ap_adjm_m), ""),
                    sb_ap_adjm_a: this.coalesce(Number(d.sb_ap_adjm_a), ""),
                    sb_ap_adjm_l: this.coalesce(Number(d.sb_ap_adjm_l), ""),
                    sb_ttl_ap_adjm: this.coalesce(Number(d.sb_ttl_ap_adjm), ""),
                    total_ap_adjm_c: this.coalesce(Number(d.ap_adjm_c) + Number(d.sb_ap_adjm_c), ""),
                    total_ap_adjm_p: this.coalesce(Number(d.ap_adjm_p) + Number(d.sb_ap_adjm_p), ""),
                    total_ap_adjm_n: this.coalesce(Number(d.ap_adjm_n) + Number(d.sb_ap_adjm_n), ""),
                    total_ap_adjm_m: this.coalesce(Number(d.ap_adjm_m) + Number(d.sb_ap_adjm_m), ""),
                    total_ap_adjm_a: this.coalesce(Number(d.ap_adjm_a) + Number(d.sb_ap_adjm_a), ""),
                    total_ap_adjm_l: this.coalesce(Number(d.ap_adjm_l) + Number(d.sb_ap_adjm_l), ""),
                    total_ap_adjm: this.coalesce(Number(d.ttl_ap_adjm) + Number(d.sb_ttl_ap_adjm), ""),

                    // appr adjusted
                    ap_adjd_c: this.coalesce(Number(d.ap_adjd_c), ""),
                    ap_adjd_p: this.coalesce(Number(d.ap_adjd_p), ""),
                    ap_adjd_n: this.coalesce(Number(d.ap_adjd_n), ""),
                    ap_adjd_m: this.coalesce(Number(d.ap_adjd_m), ""),
                    ap_adjd_a: this.coalesce(Number(d.ap_adjd_a), ""),
                    ap_adjd_l: this.coalesce(Number(d.ap_adjd_l), ""),
                    ttl_ap_adjd: this.coalesce(Number(d.ttl_ap_adjd), ""),
                    sb_ap_adjd_c: this.coalesce(Number(d.sb_ap_adjd_c), ""),
                    sb_ap_adjd_p: this.coalesce(Number(d.sb_ap_adjd_p), ""),
                    sb_ap_adjd_n: this.coalesce(Number(d.sb_ap_adjd_n), ""),
                    sb_ap_adjd_m: this.coalesce(Number(d.sb_ap_adjd_m), ""),
                    sb_ap_adjd_a: this.coalesce(Number(d.sb_ap_adjd_a), ""),
                    sb_ap_adjd_l: this.coalesce(Number(d.sb_ap_adjd_l), ""),
                    sb_ttl_ap_adjd: this.coalesce(Number(d.sb_ttl_ap_adjd), ""),
                    total_ap_adjd_c: this.coalesce(Number(d.ap_adjd_c) + Number(d.sb_ap_adjd_c), ""),
                    total_ap_adjd_p: this.coalesce(Number(d.ap_adjd_p) + Number(d.sb_ap_adjd_p), ""),
                    total_ap_adjd_n: this.coalesce(Number(d.ap_adjd_n) + Number(d.sb_ap_adjd_n), ""),
                    total_ap_adjd_m: this.coalesce(Number(d.ap_adjd_m) + Number(d.sb_ap_adjd_m), ""),
                    total_ap_adjd_a: this.coalesce(Number(d.ap_adjd_a) + Number(d.sb_ap_adjd_a), ""),
                    total_ap_adjd_l: this.coalesce(Number(d.ap_adjd_l) + Number(d.sb_ap_adjd_l), ""),
                    total_ap_adjd: this.coalesce(Number(d.ttl_ap_adjd) + Number(d.sb_ttl_ap_adjd), ""),

                    // allotment
                    al_c: this.coalesce(Number(d.al_c), ""),
                    al_p: this.coalesce(Number(d.al_p), ""),
                    al_n: this.coalesce(Number(d.al_n), ""),
                    al_m: this.coalesce(Number(d.al_m), ""),
                    al_a: this.coalesce(Number(d.al_a), ""),
                    al_l: this.coalesce(Number(d.al_l), ""),
                    ttl_al: this.coalesce(Number(d.ttl_al), ""),
                    sb_al_c: this.coalesce(Number(d.sb_al_c), ""),
                    sb_al_p: this.coalesce(Number(d.sb_al_p), ""),
                    sb_al_n: this.coalesce(Number(d.sb_al_n), ""),
                    sb_al_m: this.coalesce(Number(d.sb_al_m), ""),
                    sb_al_a: this.coalesce(Number(d.sb_al_a), ""),
                    sb_al_l: this.coalesce(Number(d.sb_al_l), ""),
                    sb_ttl_al: this.coalesce(Number(d.sb_ttl_al), ""),
                    total_al_c: this.coalesce(Number(d.al_c) + Number(d.sb_al_c), ""),
                    total_al_p: this.coalesce(Number(d.al_p) + Number(d.sb_al_p), ""),
                    total_al_n: this.coalesce(Number(d.al_n) + Number(d.sb_al_n), ""),
                    total_al_m: this.coalesce(Number(d.al_m) + Number(d.sb_al_m), ""),
                    total_al_a: this.coalesce(Number(d.al_a) + Number(d.sb_al_a), ""),
                    total_al_l: this.coalesce(Number(d.al_l) + Number(d.sb_al_l), ""),
                    total_al: this.coalesce(Number(d.ttl_al) + Number(d.sb_ttl_al), ""),

                    // allotment adjustment
                    al_adjm_c: this.coalesce(Number(d.al_adjm_c), ""),
                    al_adjm_pb: this.coalesce(Number(d.al_adjm_pb), ""),
                    al_adjm_n: this.coalesce(Number(d.al_adjm_n), ""),
                    al_adjm_m: this.coalesce(Number(d.al_adjm_m), ""),
                    al_adjm_a: this.coalesce(Number(d.al_adjm_a), ""),
                    al_adjm_l: this.coalesce(Number(d.al_adjm_l), ""),
                    ttl_al_adjm: this.coalesce(Number(d.ttl_al_adjm), ""),
                    sb_al_adjm_c: this.coalesce(Number(d.sb_al_adjm_c), ""),
                    sb_al_adjm_pb: this.coalesce(Number(d.sb_al_adjm_pb), ""),
                    sb_al_adjm_n: this.coalesce(Number(d.sb_al_adjm_n), ""),
                    sb_al_adjm_m: this.coalesce(Number(d.sb_al_adjm_m), ""),
                    sb_al_adjm_a: this.coalesce(Number(d.sb_al_adjm_a), ""),
                    sb_al_adjm_l: this.coalesce(Number(d.sb_al_adjm_l), ""),
                    sb_ttl_al_adjm: this.coalesce(Number(d.sb_ttl_al_adjm), ""),
                    total_al_adjm_c: this.coalesce(Number(d.al_adjm_c) + Number(d.sb_al_adjm_c), ""),
                    total_al_adjm_p: this.coalesce(Number(d.al_adjm_pb) + Number(d.sb_al_adjm_pb), ""),
                    total_al_adjm_n: this.coalesce(Number(d.al_adjm_n) + Number(d.sb_al_adjm_n), ""),
                    total_al_adjm_m: this.coalesce(Number(d.al_adjm_m) + Number(d.sb_al_adjm_m), ""),
                    total_al_adjm_a: this.coalesce(Number(d.al_adjm_a) + Number(d.sb_al_adjm_a), ""),
                    total_al_adjm_l: this.coalesce(Number(d.al_adjm_l) + Number(d.sb_al_adjm_l), ""),
                    total_al_adjm: this.coalesce(Number(d.ttl_al_adjm) + Number(d.sb_ttl_al_adjm), ""),

                    // allotment adjusted
                    al_adjd_c: this.coalesce(Number(d.al_adjd_c), ""),
                    al_adjd_p: this.coalesce(Number(d.al_adjd_p), ""),
                    al_adjd_n: this.coalesce(Number(d.al_adjd_n), ""),
                    al_adjd_m: this.coalesce(Number(d.al_adjd_m), ""),
                    al_adjd_a: this.coalesce(Number(d.al_adjd_a), ""),
                    al_adjd_l: this.coalesce(Number(d.al_adjd_l), ""),
                    ttl_al_adjd: this.coalesce(Number(d.ttl_al_adjd), ""),
                    sb_al_adjd_c: this.coalesce(Number(d.sb_al_adjd_c), ""),
                    sb_al_adjd_p: this.coalesce(Number(d.sb_al_adjd_p), ""),
                    sb_al_adjd_n: this.coalesce(Number(d.sb_al_adjd_n), ""),
                    sb_al_adjd_m: this.coalesce(Number(d.sb_al_adjd_m), ""),
                    sb_al_adjd_a: this.coalesce(Number(d.sb_al_adjd_a), ""),
                    sb_al_adjd_l: this.coalesce(Number(d.sb_al_adjd_l), ""),
                    sb_ttl_al_adjd: this.coalesce(Number(d.sb_ttl_al_adjd), ""),
                    total_al_adjd_c: this.coalesce(Number(d.al_adjd_c) + Number(d.sb_al_adjd_c), ""),
                    total_al_adjd_p: this.coalesce(Number(d.al_adjd_p) + Number(d.sb_al_adjd_p), ""),
                    total_al_adjd_n: this.coalesce(Number(d.al_adjd_n) + Number(d.sb_al_adjd_n), ""),
                    total_al_adjd_m: this.coalesce(Number(d.al_adjd_m) + Number(d.sb_al_adjd_m), ""),
                    total_al_adjd_a: this.coalesce(Number(d.al_adjd_a) + Number(d.sb_al_adjd_a), ""),
                    total_al_adjd_l: this.coalesce(Number(d.al_adjd_l) + Number(d.sb_al_adjd_l), ""),
                    total_al_adjd: this.coalesce(Number(d.ttl_al_adjd) + Number(d.sb_ttl_al_adjd), ""),

                    // utilization
                    ut_c: this.coalesce(Number(d.ut_c), ""),
                    ut_p: this.coalesce(Number(d.ut_p), ""),
                    ut_n: this.coalesce(Number(d.ut_n), ""),
                    ut_m: this.coalesce(Number(d.ut_m), ""),
                    ut_a: this.coalesce(Number(d.ut_a), ""),
                    ut_l: this.coalesce(Number(d.ut_l), ""),
                    ttl_ut: this.coalesce(Number(d.ttl_ut), ""),
                    sb_ut_c: this.coalesce(Number(d.sb_ut_c), ""),
                    sb_ut_p: this.coalesce(Number(d.sb_ut_p), ""),
                    sb_ut_n: this.coalesce(Number(d.sb_ut_n), ""),
                    sb_ut_m: this.coalesce(Number(d.sb_ut_m), ""),
                    sb_ut_a: this.coalesce(Number(d.sb_ut_a), ""),
                    sb_ut_l: this.coalesce(Number(d.sb_ut_l), ""),
                    sb_ttl_ut: this.coalesce(Number(d.sb_ttl_ut), ""),
                    total_ut_c: this.coalesce(Number(d.ut_c) + Number(d.sb_ut_c), ""),
                    total_ut_p: this.coalesce(Number(d.ut_p) + Number(d.sb_ut_p), ""),
                    total_ut_n: this.coalesce(Number(d.ut_n) + Number(d.sb_ut_n), ""),
                    total_ut_m: this.coalesce(Number(d.ut_m) + Number(d.sb_ut_m), ""),
                    total_ut_a: this.coalesce(Number(d.ut_a) + Number(d.sb_ut_a), ""),
                    total_ut_l: this.coalesce(Number(d.ut_l) + Number(d.sb_ut_l), ""),
                    total_ut: this.coalesce(Number(d.ttl_ut) + Number(d.sb_ttl_ut), ""),

                    // unutilized allotment
                    un_al_c: this.coalesce(Number(d.un_al_c), ""),
                    un_al_p: this.coalesce(Number(d.un_al_p), ""),
                    un_al_n: this.coalesce(Number(d.un_al_n), ""),
                    un_al_m: this.coalesce(Number(d.un_al_m), ""),
                    un_al_a: this.coalesce(Number(d.un_al_a), ""),
                    un_al_l: this.coalesce(Number(d.un_al_l), ""),
                    ttl_un_al: this.coalesce(Number(d.ttl_un_al), ""),
                    sb_un_al_c: this.coalesce(Number(d.sb_un_al_c), ""),
                    sb_un_al_p: this.coalesce(Number(d.sb_un_al_p), ""),
                    sb_un_al_n: this.coalesce(Number(d.sb_un_al_n), ""),
                    sb_un_al_m: this.coalesce(Number(d.sb_un_al_m), ""),
                    sb_un_al_a: this.coalesce(Number(d.sb_un_al_a), ""),
                    sb_un_al_l: this.coalesce(Number(d.sb_un_al_l), ""),
                    sb_ttl_un_al: this.coalesce(Number(d.sb_ttl_un_al), ""),
                    total_un_al_c: this.coalesce(Number(d.un_al_c) + Number(d.sb_un_al_c), ""),
                    total_un_al_p: this.coalesce(Number(d.un_al_p) + Number(d.sb_un_al_p), ""),
                    total_un_al_n: this.coalesce(Number(d.un_al_n) + Number(d.sb_un_al_n), ""),
                    total_un_al_m: this.coalesce(Number(d.un_al_m) + Number(d.sb_un_al_m), ""),
                    total_un_al_a: this.coalesce(Number(d.un_al_a) + Number(d.sb_un_al_a), ""),
                    total_un_al_l: this.coalesce(Number(d.un_al_l) + Number(d.sb_un_al_l), ""),
                    total_un_al: this.coalesce(Number(d.ttl_un_al) + Number(d.sb_ttl_un_al), ""),

                    // unutilized appr
                    un_ap_c: unreleased_appr[0].c,
                    un_ap_p: unreleased_appr[0].p,
                    un_ap_n: unreleased_appr[0].n,
                    un_ap_m: unreleased_appr[0].m,
                    un_ap_a: unreleased_appr[0].a,
                    un_ap_l: unreleased_appr[0].l,
                    ttl_un_ap: unreleased_appr[0].t,
                    sb_un_ap_c: unreleased_appr[1].c,
                    sb_un_ap_p: unreleased_appr[1].p,
                    sb_un_ap_n: unreleased_appr[1].n,
                    sb_un_ap_m: unreleased_appr[1].m,
                    sb_un_ap_a: unreleased_appr[1].a,
                    sb_un_ap_l: unreleased_appr[1].l,
                    sb_ttl_un_ap: unreleased_appr[1].t,
                    total_un_ap_c: this.coalesce(Number(unreleased_appr[0].c) + Number(unreleased_appr[1].c), ""),
                    total_un_ap_p: this.coalesce(Number(unreleased_appr[0].p) + Number(unreleased_appr[1].p), ""),
                    total_un_ap_n: this.coalesce(Number(unreleased_appr[0].n) + Number(unreleased_appr[1].n), ""),
                    total_un_ap_m: this.coalesce(Number(unreleased_appr[0].m) + Number(unreleased_appr[1].m), ""),
                    total_un_ap_a: this.coalesce(Number(unreleased_appr[0].a) + Number(unreleased_appr[1].a), ""),
                    total_un_ap_l: this.coalesce(Number(unreleased_appr[0].l) + Number(unreleased_appr[1].l), ""),
                    total_un_ap: this.coalesce(Number(unreleased_appr[0].t) + Number(unreleased_appr[1].t), ""),

                    // disbursement
                    d_c: this.coalesce(Number(d.d_c), ""),
                    d_p: this.coalesce(Number(d.d_p), ""),
                    d_n: this.coalesce(Number(d.d_n), ""),
                    d_m: this.coalesce(Number(d.d_m), ""),
                    d_a: this.coalesce(Number(d.d_a), ""),
                    d_l: this.coalesce(Number(d.d_l), ""),
                    ttl_d: this.coalesce(Number(d.ttl_d), ""),
                    sb_d_c: this.coalesce(Number(d.sb_d_c), ""),
                    sb_d_p: this.coalesce(Number(d.sb_d_p), ""),
                    sb_d_n: this.coalesce(Number(d.sb_d_n), ""),
                    sb_d_m: this.coalesce(Number(d.sb_d_m), ""),
                    sb_d_a: this.coalesce(Number(d.sb_d_a), ""),
                    sb_d_l: this.coalesce(Number(d.sb_d_l), ""),
                    sb_ttl_d: this.coalesce(Number(d.sb_ttl_d), ""),
                    total_d_c: this.coalesce(Number(d.d_c) + Number(d.sb_d_c), ""),
                    total_d_p: this.coalesce(Number(d.d_p) + Number(d.sb_d_p), ""),
                    total_d_n: this.coalesce(Number(d.d_n) + Number(d.sb_d_n), ""),
                    total_d_m: this.coalesce(Number(d.d_m) + Number(d.sb_d_m), ""),
                    total_d_a: this.coalesce(Number(d.d_a) + Number(d.sb_d_a), ""),
                    total_d_l: this.coalesce(Number(d.d_l) + Number(d.sb_d_l), ""),
                    total_d: this.coalesce(Number(d.ttl_d) + Number(d.sb_ttl_d), ""),

                    // due and demmandable
                    dnd_c: this.coalesce(Number(d.ut_c) - Number(d.d_c), ""),
                    dnd_p: this.coalesce(Number(d.ut_p) - Number(d.d_p), ""),
                    dnd_n: this.coalesce(Number(d.ut_n) - Number(d.d_n), ""),
                    dnd_m: this.coalesce(Number(d.ut_m) - Number(d.d_m), ""),
                    dnd_a: this.coalesce(Number(d.ut_a) - Number(d.d_a), ""),
                    dnd_l: this.coalesce(Number(d.ut_l) - Number(d.d_l), ""),
                    ttl_dnd: this.coalesce(Number(d.ttl_ut) - Number(d.ttl_d), ""),
                    sb_dnd_c: this.coalesce(Number(d.sb_ut_c) - Number(d.sb_d_c), ""),
                    sb_dnd_p: this.coalesce(Number(d.sb_ut_p) - Number(d.sb_d_p), ""),
                    sb_dnd_n: this.coalesce(Number(d.sb_ut_n) - Number(d.sb_d_n), ""),
                    sb_dnd_m: this.coalesce(Number(d.sb_ut_m) - Number(d.sb_d_m), ""),
                    sb_dnd_a: this.coalesce(Number(d.sb_ut_a) - Number(d.sb_d_a), ""),
                    sb_dnd_l: this.coalesce(Number(d.sb_ut_l) - Number(d.sb_d_l), ""),
                    sb_ttl_dnd: this.coalesce(Number(d.sb_ttl_ut) - Number(d.sb_ttl_d), ""),
                    tsb_ttl_utotal_dnd_c: this.coalesce((Number(d.ut_c) - Number(d.d_c)) + (Number(d.sb_ut_c) - Number(d.sb_d_c)), ""),
                    total_dnd_p: this.coalesce((Number(d.ut_p) - Number(d.d_p)) + (Number(d.sb_ut_p) - Number(d.sb_d_p)), ""),
                    total_dnd_n: this.coalesce((Number(d.ut_n) - Number(d.d_n)) + (Number(d.sb_ut_n) - Number(d.sb_d_n)), ""),
                    total_dnd_m: this.coalesce((Number(d.ut_m) - Number(d.d_m)) + (Number(d.sb_ut_m) - Number(d.sb_d_m)), ""),
                    total_dnd_a: this.coalesce((Number(d.ut_a) - Number(d.d_a)) + (Number(d.sb_ut_a) - Number(d.sb_d_a)), ""),
                    total_dnd_l: this.coalesce((Number(d.ut_l) - Number(d.d_l)) + (Number(d.sb_ut_l) - Number(d.sb_d_l)), ""),
                    total_dnd: this.coalesce((Number(d.ttl_ut) - Number(d.ttl_d)) + (Number(d.sb_ttl_ut) - Number(d.sb_ttl_d)), ""),

                    // not yet due and demandable
                    nydnd_c: this.coalesce(nydnd[0].c, ""),
                    nydnd_p: this.coalesce(nydnd[0].p, ""),
                    nydnd_n: this.coalesce(nydnd[0].n, ""),
                    nydnd_m: this.coalesce(nydnd[0].m, ""),
                    nydnd_a: this.coalesce(nydnd[0].a, ""),
                    nydnd_l: this.coalesce(nydnd[0].l, ""),
                    ttl_nydnd: this.coalesce(nydnd[0].t, ""),
                    sb_nydnd_c: this.coalesce(nydnd[1].c, ""),
                    sb_nydnd_p: this.coalesce(nydnd[1].p, ""),
                    sb_nydnd_n: this.coalesce(nydnd[1].n, ""),
                    sb_nydnd_m: this.coalesce(nydnd[1].m, ""),
                    sb_nydnd_a: this.coalesce(nydnd[1].a, ""),
                    sb_nydnd_l: this.coalesce(nydnd[1].l, ""),
                    sb_ttl_nydnd: this.coalesce(nydnd[1].t, ""),
                    total_nydnd_c: this.coalesce(nydnd[0].c - nydnd[1].c, ""),
                    total_nydnd_p: this.coalesce(nydnd[0].p - nydnd[1].p, ""),
                    total_nydnd_n: this.coalesce(nydnd[0].n - nydnd[1].n, ""),
                    total_nydnd_m: this.coalesce(nydnd[0].m - nydnd[1].m, ""),
                    total_nydnd_a: this.coalesce(nydnd[0].a - nydnd[1].a, ""),
                    total_nydnd_l: this.coalesce(nydnd[0].l - nydnd[1].l, ""),
                    total_ttl_nydnd: this.coalesce(nydnd[0].t - nydnd[1].t, ""),
                });

                // ws.addRow({
                //     part: `${this.getNumber(d)}${d.part}`,
                //     uacs: (d.ac == null || d.ac == "99" || d.ac == "98" || d.uacs == null || d.uacs == "0000000000" || exclude_particulars.includes(d.part.toLowerCase())) ? "" : d.uacs,
                //     ap_c: this.numService.isNumber(d.ap_c) ? Number(d.ap_c) : "",
                //     ap_p: this.numService.isNumber(d.ap_p) ? Number(d.ap_p) : "",
                //     ap_n: this.numService.isNumber(d.ap_n) ? Number(d.ap_n) : "",
                //     ap_m: this.numService.isNumber(d.ap_m) ? Number(d.ap_m) : "",
                //     ap_a: this.numService.isNumber(d.ap_a) ? Number(d.ap_a) : "",
                //     ap_l: this.numService.isNumber(d.ap_l) ? Number(d.ap_l) : "",
                //     ttl_ap: this.numService.isNumber(d.ttl_ap) ? Number(d.ttl_ap) : "",
                //     ap_adjm_c: this.numService.isNumber(d.ap_adjm_c) ? Number(d.ap_adjm_c) : "",
                //     ap_adjm_p: this.numService.isNumber(d.ap_adjm_p) ? Number(d.ap_adjm_p) : "",
                //     ap_adjm_n: this.numService.isNumber(d.ap_adjm_n) ? Number(d.ap_adjm_n) : "",
                //     ap_adjm_m: this.numService.isNumber(d.ap_adjm_m) ? Number(d.ap_adjm_m) : "",
                //     ap_adjm_a: this.numService.isNumber(d.ap_adjm_a) ? Number(d.ap_adjm_a) : "",
                //     ap_adjm_l: this.numService.isNumber(d.ap_adjm_l) ? Number(d.ap_adjm_l) : "",
                //     ttl_ap_adjm: this.numService.isNumber(d.ttl_ap_adjm) ? Number(d.ttl_ap_adjm) : "",
                //     ap_adjd_c: this.numService.isNumber(d.ap_adjd_c) ? Number(d.ap_adjd_c) : "",
                //     ap_adjd_p: this.numService.isNumber(d.ap_adjd_p) ? Number(d.ap_adjd_p) : "",
                //     ap_adjd_n: this.numService.isNumber(d.ap_adjd_n) ? Number(d.ap_adjd_n) : "",
                //     ap_adjd_m: this.numService.isNumber(d.ap_adjd_m) ? Number(d.ap_adjd_m) : "",
                //     ap_adjd_a: this.numService.isNumber(d.ap_adjd_a) ? Number(d.ap_adjd_a) : "",
                //     ap_adjd_l: this.numService.isNumber(d.ap_adjd_l) ? Number(d.ap_adjd_l) : "",
                //     ttl_ap_adjd: this.numService.isNumber(d.ttl_ap_adjd) ? Number(d.ttl_ap_adjd) : "",
                //     al_c: this.numService.isNumber(d.al_c) ? Number(d.al_c) : "",
                //     al_p: this.numService.isNumber(d.al_p) ? Number(d.al_p) : "",
                //     al_n: this.numService.isNumber(d.al_n) ? Number(d.al_n) : "",
                //     al_m: this.numService.isNumber(d.al_m) ? Number(d.al_m) : "",
                //     al_a: this.numService.isNumber(d.al_a) ? Number(d.al_a) : "",
                //     al_l: this.numService.isNumber(d.al_l) ? Number(d.al_l) : "",
                //     ttl_al: this.numService.isNumber(d.ttl_al) ? Number(d.ttl_al) : "",
                //     al_adjm_c: this.numService.isNumber(d.al_adjm_c) ? Number(d.al_adjm_c) : "",
                //     al_adjm_p: this.numService.isNumber(d.al_adjm_p) ? Number(d.al_adjm_p) : "",
                //     al_adjm_n: this.numService.isNumber(d.al_adjm_n) ? Number(d.al_adjm_n) : "",
                //     al_adjm_m: this.numService.isNumber(d.al_adjm_m) ? Number(d.al_adjm_m) : "",
                //     al_adjm_a: this.numService.isNumber(d.al_adjm_a) ? Number(d.al_adjm_a) : "",
                //     al_adjm_l: this.numService.isNumber(d.al_adjm_l) ? Number(d.al_adjm_l) : "",
                //     ttl_al_adjm: this.numService.isNumber(d.ttl_al_adjm) ? Number(d.ttl_al_adjm) : "",
                //     al_adjd_c: this.numService.isNumber(d.al_adjd_c) ? Number(d.al_adjd_c) : "",
                //     al_adjd_p: this.numService.isNumber(d.al_adjd_p) ? Number(d.al_adjd_p) : "",
                //     al_adjd_n: this.numService.isNumber(d.al_adjd_n) ? Number(d.al_adjd_n) : "",
                //     al_adjd_m: this.numService.isNumber(d.al_adjd_m) ? Number(d.al_adjd_m) : "",
                //     al_adjd_a: this.numService.isNumber(d.al_adjd_a) ? Number(d.al_adjd_a) : "",
                //     al_adjd_l: this.numService.isNumber(d.al_adjd_l) ? Number(d.al_adjd_l) : "",
                //     ttl_al_adjd: this.numService.isNumber(d.ttl_al_adjd) ? Number(d.ttl_al_adjd) : "",
                //     ut_c: this.numService.isNumber(d.ut_c) ? Number(d.ut_c) : "",
                //     ut_p: this.numService.isNumber(d.ut_p) ? Number(d.ut_p) : "",
                //     ut_n: this.numService.isNumber(d.ut_n) ? Number(d.ut_n) : "",
                //     ut_m: this.numService.isNumber(d.ut_m) ? Number(d.ut_m) : "",
                //     ut_a: this.numService.isNumber(d.ut_a) ? Number(d.ut_a) : "",
                //     ut_l: this.numService.isNumber(d.ut_l) ? Number(d.ut_l) : "",
                //     ttl_ut: this.numService.isNumber(d.ttl_ut) ? Number(d.ttl_ut) : "",
                //     un_al_c: this.numService.isNumber(d.un_al_c) ? Number(d.un_al_c) : "",
                //     un_al_p: this.numService.isNumber(d.un_al_p) ? Number(d.un_al_p) : "",
                //     un_al_n: this.numService.isNumber(d.un_al_n) ? Number(d.un_al_n) : "",
                //     un_al_m: this.numService.isNumber(d.un_al_m) ? Number(d.un_al_m) : "",
                //     un_al_a: this.numService.isNumber(d.un_al_a) ? Number(d.un_al_a) : "",
                //     un_al_l: this.numService.isNumber(d.un_al_l) ? Number(d.un_al_l) : "",
                //     ttl_un_al: this.numService.isNumber(d.ttl_un_al) ? Number(d.ttl_un_al) : "",
                //     d_c: this.numService.isNumber(d.d_c) ? Number(d.d_c) : "",
                //     d_p: this.numService.isNumber(d.d_p) ? Number(d.d_p) : "",
                //     d_n: this.numService.isNumber(d.d_n) ? Number(d.d_n) : "",
                //     d_m: this.numService.isNumber(d.d_m) ? Number(d.d_m) : "",
                //     d_a: this.numService.isNumber(d.d_a) ? Number(d.d_a) : "",
                //     d_l: this.numService.isNumber(d.d_l) ? Number(d.d_l) : "",
                //     ttl_d: this.numService.isNumber(d.ttl_d) ? Number(d.ttl_d) : "",
                //     dnd_c: this.numService.isNumber(d.pybl_c) ? Number(d.pybl_c) - Number(d.d_c) : "",
                //     dnd_p: this.numService.isNumber(d.pybl_p) ? Number(d.pybl_p) - Number(d.d_p) : "",
                //     dnd_n: this.numService.isNumber(d.pybl_n) ? Number(d.pybl_n) - Number(d.d_n) : "",
                //     dnd_m: this.numService.isNumber(d.pybl_m) ? Number(d.pybl_m) - Number(d.d_m) : "",
                //     dnd_a: this.numService.isNumber(d.pybl_a) ? Number(d.pybl_a) - Number(d.d_a) : "",
                //     dnd_l: this.numService.isNumber(d.pybl_l) ? Number(d.pybl_l) - Number(d.d_l) : "",
                //     ttl_dnd: this.numService.isNumber(d.ttl_pybl) ? Number(d.ttl_pybl) - Number(d.ttl_d) : "",
                //     nydnd_c: this.numService.isNumber(d.ut_c) ? Number(d.ut_c) - Number(d.pybl_c) : "",
                //     nydnd_p: this.numService.isNumber(d.ut_p) ? Number(d.ut_p) - Number(d.pybl_p) : "",
                //     nydnd_n: this.numService.isNumber(d.ut_n) ? Number(d.ut_n) - Number(d.pybl_n) : "",
                //     nydnd_m: this.numService.isNumber(d.ut_m) ? Number(d.ut_m) - Number(d.pybl_m) : "",
                //     nydnd_a: this.numService.isNumber(d.ut_a) ? Number(d.ut_a) - Number(d.pybl_a) : "",
                //     nydnd_l: this.numService.isNumber(d.ut_l) ? Number(d.ut_l) - Number(d.pybl_l) : "",
                //     ttl_nydnd: this.numService.isNumber(d.ttl_ut) ? Number(d.ttl_ut) - Number(d.ttl_pybl) : ""
                // });

                this.detailed_columns.forEach((col: string, index: number) => {
                    let cell = ws.getCell(`${col}${(this.startPosition + 3) + i}`);
                    if (index >= 2) {
                        cell.style = { numFmt: this.numberFormat };
                    }
                    if (d.uacs == null || d.ac == null || exclude_uacs_pattern.includes(d.uacs.substring(3))) {
                        cell.font = this.fontStyle.header;
                    } else {
                        cell.font = this.fontStyle.content;
                    }
                    cell.border = this.borderStyle.full;
                    cell.alignment = {
                        wrapText: true,
                        vertical: 'middle',
                        horizontal: (col == 'A') ? 'left' : 'right',
                        indent: (col == 'A' && this.indention(d)) ? 2 : 0
                    };
                });
            });

            const arrayData = await wb.xlsx.writeBuffer();
            const blob = new Blob([arrayData], { type: "application/octet-binary" });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `${options.fileName}.xlsx`;
            a.click();
            a.remove();
        });
    }

    async generateSummary(data: Array<any>, campus: number, options: any = { fileName: "Consolidated_SABAUDB_Summary", sheetName: "Summary" }) {
        const wb = new ExcelJS.Workbook();
        wb.addWorksheet(options.sheetName);

        const ws = wb.getWorksheet(options.sheetName);

        const imagePath = './assets/BatStateULogo.png';

        this.sysUtil.getBase64ImageFromUrl(imagePath).then(async (result: any) => {

            let imageId = wb.addImage({ base64: result, extension: 'png' });
            ws.addImage(imageId, { tl: { col: 13, row: 2 }, ext: { width: 120, height: 110 } });

            ws.columns = [
                { header: "", key: "part", width: 48 },
                { header: "", key: "uacs", width: 16 },

                // approved budget 
                { header: "", key: "ttl_ap", width: 16 },
                { header: "", key: "sb_ttl_ap", width: 16 },
                { header: "", key: "total_ap", width: 16 },
                // approved budget adjustment
                { header: "", key: "ttl_ap_adjm", width: 16 },
                { header: "", key: "sb_ttl_ap_adjm", width: 16 },
                { header: "", key: "total_ap_adjm", width: 16 },
                // approved budget adjusted
                { header: "", key: "ttl_ap_adjd", width: 16 },
                { header: "", key: "sb_ttl_ap_adjd", width: 16 },
                { header: "", key: "total_ap_adjd", width: 16 },

                // allotment received
                { header: "", key: "ttl_al", width: 16 },
                { header: "", key: "sb_ttl_al", width: 16 },
                { header: "", key: "total_al", width: 16 },
                // allotment adjustment
                { header: "", key: "ttl_al_adjm", width: 16 },
                { header: "", key: "sb_ttl_al_adjm", width: 16 },
                { header: "", key: "total_al_adjm", width: 16 },
                // allotment adjusted
                { header: "", key: "ttl_al_adjd", width: 16 },
                { header: "", key: "sb_ttl_al_adjd", width: 16 },
                { header: "", key: "total_al_adjd", width: 16 },

                // utilizations
                { header: "", key: "ttl_ut", width: 16 },
                { header: "", key: "sb_ttl_ut", width: 16 },
                { header: "", key: "total_ut", width: 16 },

                // unobligated allotment blance
                { header: "", key: "ttl_un_al", width: 16 },
                { header: "", key: "sb_ttl_un_al", width: 16 },
                { header: "", key: "total_un_al", width: 16 },

                // unreleased approved budget
                { header: "", key: "ttl_un_ap", width: 16 },
                { header: "", key: "sb_ttl_un_ap", width: 16 },
                { header: "", key: "total_un_ap", width: 16 },

                // disbursement
                { header: "", key: "ttl_d", width: 16 },
                { header: "", key: "sb_ttl_d", width: 16 },
                { header: "", key: "total_d", width: 16 },

                // due and demmandable
                { header: "", key: "ttl_dnd", width: 16 },
                { header: "", key: "sb_ttl_dnd", width: 16 },
                { header: "", key: "total_dnd", width: 16 },

                // not yet due and demandable
                { header: "", key: "ttl_nydnd", width: 16 },
                { header: "", key: "sb_ttl_nydnd", width: 16 },
                { header: "", key: "total_ttl_nydnd", width: 16 },

            ];

            console.log(`ExcelConsolidatedSABAUDB->generateDetailed()->data`, data);

            this.setDocumentHeader(ws, campus, "AL", true);

            this.setSummaryHeader(ws);

            const exclude_particulars = ['sub-total', 'total', 'grand total'];
            const exclude_uacs_pattern = ["0000000", "9999999"];

            data.forEach((d: any, i: number) => {

                let nydnd = [
                    // PRE
                    {
                        c: (Number(d.ut_c) - Number(d.d_c)) - (Number(d.ut_c) - Number(d.d_c)),
                        p: (Number(d.ut_p) - Number(d.d_p)) - (Number(d.ut_p) - Number(d.d_p)),
                        n: (Number(d.ut_n) - Number(d.d_n)) - (Number(d.ut_n) - Number(d.d_n)),
                        m: (Number(d.ut_m) - Number(d.d_m)) - (Number(d.ut_m) - Number(d.d_m)),
                        a: (Number(d.ut_a) - Number(d.d_a)) - (Number(d.ut_a) - Number(d.d_a)),
                        l: (Number(d.ut_l) - Number(d.d_l)) - (Number(d.ut_l) - Number(d.d_l)),
                        t: (Number(d.ttl_ut) - Number(d.ttl_d)) - (Number(d.ttl_ut) - Number(d.ttl_d)),
                    },
                    // SUPPLEMENTAL
                    {
                        c: (Number(d.sb_ut_c) - Number(d.sb_d_c)) - (Number(d.sb_ut_c) - Number(d.sb_d_c)),
                        p: (Number(d.sb_ut_p) - Number(d.sb_d_p)) - (Number(d.sb_ut_p) - Number(d.sb_d_p)),
                        n: (Number(d.sb_ut_n) - Number(d.sb_d_n)) - (Number(d.sb_ut_n) - Number(d.sb_d_n)),
                        m: (Number(d.sb_ut_m) - Number(d.sb_d_m)) - (Number(d.sb_ut_m) - Number(d.sb_d_m)),
                        a: (Number(d.sb_ut_a) - Number(d.sb_d_a)) - (Number(d.sb_ut_a) - Number(d.sb_d_a)),
                        l: (Number(d.sb_ut_l) - Number(d.sb_d_l)) - (Number(d.sb_ut_l) - Number(d.sb_d_l)),
                        t: (Number(d.sb_ttl_ut) - Number(d.sb_ttl_d)) - (Number(d.sb_ttl_ut) - Number(d.sb_ttl_d)),
                    }
                ];

                let unreleased_appr = [
                    {
                        c: this.coalesce(Number(d.ap_adjd_c) - Number(d.al_adjd_c), ""),
                        p: this.coalesce(Number(d.ap_adjd_p) - Number(d.al_adjd_p), ""),
                        n: this.coalesce(Number(d.ap_adjd_n) - Number(d.al_adjd_n), ""),
                        m: this.coalesce(Number(d.ap_adjd_m) - Number(d.al_adjd_m), ""),
                        a: this.coalesce(Number(d.ap_adjd_a) - Number(d.al_adjd_a), ""),
                        l: this.coalesce(Number(d.ap_adjd_l) - Number(d.al_adjd_l), ""),
                        t: this.coalesce(Number(d.ttl_ap_adjd) - Number(d.ttl_al_adjd), ""),
                    }, {
                        c: this.coalesce(Number(d.sb_ap_adjd_c) - Number(d.sb_al_adjd_c), ""),
                        p: this.coalesce(Number(d.sb_ap_adjd_p) - Number(d.sb_al_adjd_p), ""),
                        n: this.coalesce(Number(d.sb_ap_adjd_n) - Number(d.sb_al_adjd_n), ""),
                        m: this.coalesce(Number(d.sb_ap_adjd_m) - Number(d.sb_al_adjd_m), ""),
                        a: this.coalesce(Number(d.sb_ap_adjd_a) - Number(d.sb_al_adjd_a), ""),
                        l: this.coalesce(Number(d.sb_ap_adjd_l) - Number(d.sb_al_adjd_l), ""),
                        t: this.coalesce(Number(d.sb_ttl_ap_adjd) - Number(d.sb_ttl_al_adjd), ""),
                    }
                ];

                ws.addRow({
                    part: `${this.getNumber(d)}${d.part}`,
                    uacs: (d.ac == null || d.ac == "99" || d.ac == "98" || d.uacs == null || d.uacs == "0000000000" || exclude_particulars.includes(d.part.toLowerCase())) ? "" : d.uacs,

                    // appr
                    ttl_ap: this.coalesce(Number(d.ttl_ap), ""),
                    sb_ttl_ap: this.coalesce(Number(d.sb_ttl_ap), ""),
                    total_ap: this.coalesce(Number(d.ttl_ap) + Number(d.sb_ttl_ap), ""),
                    // appr adjustment
                    ttl_ap_adjm: this.coalesce(Number(d.ttl_ap_adjm), ""),
                    sb_ttl_ap_adjm: this.coalesce(Number(d.sb_ttl_ap_adjm), ""),
                    total_ap_adjm: this.coalesce(Number(d.ttl_ap_adjm) + Number(d.sb_ttl_ap_adjm), ""),
                    // appr adjusted
                    ttl_ap_adjd: this.coalesce(Number(d.ttl_ap_adjd), ""),
                    sb_ttl_ap_adjd: this.coalesce(Number(d.sb_ttl_ap_adjd), ""),
                    total_ap_adjd: this.coalesce(Number(d.ttl_ap_adjd) + Number(d.sb_ttl_ap_adjd), ""),

                    // allotment
                    ttl_al: this.coalesce(Number(d.ttl_al), ""),
                    sb_ttl_al: this.coalesce(Number(d.sb_ttl_al), ""),
                    total_al: this.coalesce(Number(d.ttl_al) + Number(d.sb_ttl_al), ""),
                    // allotment adjustment
                    ttl_al_adjm: this.coalesce(Number(d.ttl_al_adjm), ""),
                    sb_ttl_al_adjm: this.coalesce(Number(d.sb_ttl_al_adjm), ""),
                    total_al_adjm: this.coalesce(Number(d.ttl_al_adjm) + Number(d.sb_ttl_al_adjm), ""),
                    // allotment adjusted
                    ttl_al_adjd: this.coalesce(Number(d.ttl_al_adjd), ""),
                    sb_ttl_al_adjd: this.coalesce(Number(d.sb_ttl_al_adjd), ""),
                    total_al_adjd: this.coalesce(Number(d.ttl_al_adjd) + Number(d.sb_ttl_al_adjd), ""),

                    // utilization
                    ttl_ut: this.coalesce(Number(d.ttl_ut), ""),
                    sb_ttl_ut: this.coalesce(Number(d.sb_ttl_ut), ""),
                    total_ut: this.coalesce(Number(d.ttl_ut) + Number(d.sb_ttl_ut), ""),

                    // unutilized allotment
                    ttl_un_al: this.coalesce(Number(d.ttl_un_al), ""),
                    sb_ttl_un_al: this.coalesce(Number(d.sb_ttl_un_al), ""),
                    total_un_al: this.coalesce(Number(d.ttl_un_al) + Number(d.sb_ttl_un_al), ""),

                    // unutilized appr
                    ttl_un_ap: unreleased_appr[0].t,
                    sb_ttl_un_ap: unreleased_appr[1].t,
                    total_un_ap: this.coalesce(Number(unreleased_appr[0].t) + Number(unreleased_appr[1].t), ""),

                    // disbursement
                    ttl_d: this.coalesce(Number(d.ttl_d), ""),
                    sb_ttl_d: this.coalesce(Number(d.sb_ttl_d), ""),
                    total_d: this.coalesce(Number(d.ttl_d) + Number(d.sb_ttl_d), ""),

                    // due and demmandable
                    ttl_dnd: this.coalesce(Number(d.ttl_ut) - Number(d.ttl_d), ""),
                    sb_ttl_dnd: this.coalesce(Number(d.sb_ttl_ut) - Number(d.sb_ttl_d), ""),
                    total_dnd: this.coalesce((Number(d.ttl_ut) - Number(d.ttl_d)) + (Number(d.sb_ttl_ut) - Number(d.sb_ttl_d)), ""),

                    // not yet due and demandable
                    ttl_nydnd: this.coalesce(nydnd[0].t, ""),
                    sb_ttl_nydnd: this.coalesce(nydnd[1].t, ""),
                    total_ttl_nydnd: this.coalesce(nydnd[0].t - nydnd[1].t, ""),
                });

                this.summary_columns.forEach((col: string, index: number) => {
                    let cell = ws.getCell(`${col}${(this.startPosition + 3) + i}`);
                    if (index >= 2) {
                        cell.style = { numFmt: this.numberFormat };
                    }
                    if (d.uacs == null || d.ac == null || exclude_uacs_pattern.includes(d.uacs.substring(3))) {
                        cell.font = this.fontStyle.header;
                    } else {
                        cell.font = this.fontStyle.content;
                    }
                    cell.border = this.borderStyle.full;
                    cell.alignment = {
                        wrapText: true,
                        vertical: 'middle',
                        horizontal: (col == 'A') ? 'left' : 'right',
                        indent: (col == 'A' && this.indention(d)) ? 2 : 0
                    };
                });
            });

            const arrayData = await wb.xlsx.writeBuffer();
            const blob = new Blob([arrayData], { type: "application/octet-binary" });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `${options.fileName}.xlsx`;
            a.click();
            a.remove();
        });
    }

    private setDocumentHeader(ws: ExcelJS.Worksheet, campus: number, lastcell: string = "CA", sb: boolean = false) {
        let supplemental = (sb) ? " & Supplemental Budget (SB)" : "";

        let campus_details = env.campuses.find((c: any) => c.value === campus);

        let header_details = [
            "Republic of the Philippines",
            "BATANGAS STATE UNIVERSITY",
            "The National Engineering University",
            campus_details.details.name,
            campus_details.details.addr,
            campus_details.details.contact,
            campus_details.details.email,
            "",
            "Summary of Approved Budget, Allotment, Utilizations & Balances (SABAUDB)",
            `Program of Receipts and Expenditures (PRE) ${supplemental} of Fund 164`,
            "as of ____________________"
        ];

        header_details.forEach((d: any, i: number) => {
            ws.mergeCells(`A${i + 1}:${lastcell}${i + 1}`)
            let cell = ws.getCell(`A${i + 1}`);
            cell.value = d;
            if ((i > 0 && i < 4) || (i > 7 && i < 10)) {
                cell.font = this.fontStyle.header;
            } else {
                cell.font = this.fontStyle.content;
            }
            cell.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };
        });
    }

    private setPREHeader(ws: ExcelJS.Worksheet) {

        let cells = [
            {
                mergeCell: `A${this.startPosition}:A${this.startPosition + 2}`,
                name: "Particulars",
                cell: `A${this.startPosition + 2}`
            }, {
                mergeCell: `B${this.startPosition}:B${this.startPosition + 2}`,
                name: "UACS Code",
                cell: `B${this.startPosition + 2}`
            }, {
                mergeCell: `C${this.startPosition}:W${this.startPosition}`,
                name: "Approved Budget",
                cell: `W${this.startPosition}`
            }, {
                mergeCell: `C${this.startPosition + 1}:I${this.startPosition + 1}`,
                name: "Approved Budget",
                cell: `I${this.startPosition + 1}`
            }, {
                mergeCell: `J${this.startPosition + 1}:P${this.startPosition + 1}`,
                name: "Adjustments",
                cell: `P${this.startPosition + 1}`
            }, {
                mergeCell: `Q${this.startPosition + 1}:W${this.startPosition + 1}`,
                name: "Adjusted",
                cell: `W${this.startPosition + 1}`
            }, {
                mergeCell: `X${this.startPosition}:AR${this.startPosition}`,
                name: "Allotments",
                cell: `AR${this.startPosition}`
            }, {
                mergeCell: `X${this.startPosition + 1}:AD${this.startPosition + 1}`,
                name: "Allotment Received",
                cell: `AD${this.startPosition + 1}`
            }, {
                mergeCell: `AE${this.startPosition + 1}:AK${this.startPosition + 1}`,
                name: "Adjustments (Reduction, Modification)",
                cell: `AK${this.startPosition + 1}`
            }, {
                mergeCell: `AL${this.startPosition + 1}:AR${this.startPosition + 1}`,
                name: "Adjusted Allotment Received",
                cell: `AR${this.startPosition + 1}`
            }, {
                mergeCell: `AS${this.startPosition}:AY${this.startPosition + 1}`,
                name: "Utilizations",
                cell: `AY${this.startPosition + 1}`
            }, {
                mergeCell: `AZ${this.startPosition}:BF${this.startPosition + 1}`,
                name: "Unobligated Balance",
                cell: `BF${this.startPosition + 1}`
            }, {
                mergeCell: `BG${this.startPosition}:BM${this.startPosition + 1}`,
                name: "Disbursement",
                cell: `BM${this.startPosition + 1}`
            }, {
                mergeCell: `BN${this.startPosition}:CA${this.startPosition}`,
                name: "Unpaid Balance",
                cell: `CA${this.startPosition}`
            }, {
                mergeCell: `BN${this.startPosition + 1}:BT${this.startPosition + 1}`,
                name: "Due and Demandable",
                cell: `BT${this.startPosition + 1}`
            }, {
                mergeCell: `BU${this.startPosition + 1}:CA${this.startPosition + 1}`,
                name: "Not Yet Due and Demandable",
                cell: `CA${this.startPosition + 1}`
            }
        ];

        cells.forEach((c: any) => {
            ws.mergeCells(c.mergeCell);
            let cell = ws.getCell(c.cell);
            cell.value = c.name;
            cell.font = this.fontStyle.header;
            cell.border = this.borderStyle.full;
            cell.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };
        });

        let details = [
            { name: "Central Admin" },
            { name: "BatStateU-Pablo Borbon" },
            { name: "BatStateU-Alangilan" },
            { name: "BatStateU-Lipa" },
            { name: "BatStateU-Malvar JPLPC" },
            { name: "BatStateU-Nasugbu ARASOF" },
            { name: "Total" }
        ];

        for (let i = 2; i < this.columns.length; i += 7) {
            details.forEach((d: any, index: number) => {
                let cell = ws.getCell(`${this.columns[i + index]}${this.startPosition + 2}`);
                cell.value = d.name;
                cell.font = this.fontStyle.header;
                cell.border = this.borderStyle.full;
                cell.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };
            });
        }

        ws.getRow(this.startPosition + 2).height = 40;

    }

    private setDetailedHeader(ws: ExcelJS.Worksheet) {

        let cells = [
            {
                mergeCell: `A${this.startPosition}:A${this.startPosition + 2}`,
                name: "Particulars",
                cell: `A${this.startPosition + 2}`
            }, {
                mergeCell: `B${this.startPosition}:B${this.startPosition + 2}`,
                name: "UACS Code",
                cell: `B${this.startPosition + 2}`
            }, {
                mergeCell: `C${this.startPosition}:BM${this.startPosition}`,
                name: "Approved Budget",
                cell: `BM${this.startPosition}`
            }, {
                mergeCell: `C${this.startPosition + 1}:I${this.startPosition + 1}`,
                name: "Program of Receipt & Expenditures",
                cell: `I${this.startPosition + 1}`
            }, {
                mergeCell: `J${this.startPosition + 1}:P${this.startPosition + 1}`,
                name: "Supplemental Budget",
                cell: `P${this.startPosition + 1}`
            }, {
                mergeCell: `Q${this.startPosition + 1}:W${this.startPosition + 1}`,
                name: "Total Approved Budget",
                cell: `W${this.startPosition + 1}`
            }, {
                mergeCell: `X${this.startPosition + 1}:AD${this.startPosition + 1}`,
                name: "Adjustment PRE",
                cell: `AD${this.startPosition + 1}`
            }, {
                mergeCell: `AE${this.startPosition + 1}:AK${this.startPosition + 1}`,
                name: "Adjustment SB",
                cell: `AK${this.startPosition + 1}`
            }, {
                mergeCell: `AL${this.startPosition + 1}:AR${this.startPosition + 1}`,
                name: "Adjustments",
                cell: `AR${this.startPosition + 1}`
            }, {
                mergeCell: `AS${this.startPosition + 1}:AY${this.startPosition + 1}`,
                name: "Adjusted PRE",
                cell: `AY${this.startPosition + 1}`
            }, {
                mergeCell: `AZ${this.startPosition + 1}:BF${this.startPosition + 1}`,
                name: "Adjusted SB",
                cell: `BF${this.startPosition + 1}`
            }, {
                mergeCell: `BG${this.startPosition + 1}:BM${this.startPosition + 1}`,
                name: "Adjusted Approved Budget",
                cell: `BM${this.startPosition + 1}`
            }, {
                mergeCell: `BN${this.startPosition}:DX${this.startPosition}`,
                name: "Allotments",
                cell: `DX${this.startPosition}`
            }, {
                mergeCell: `BN${this.startPosition + 1}:BT${this.startPosition + 1}`,
                name: "Allotment Received PRE",
                cell: `BT${this.startPosition + 1}`
            }, {
                mergeCell: `BU${this.startPosition + 1}:CA${this.startPosition + 1}`,
                name: "Allotment Received SB",
                cell: `CA${this.startPosition + 1}`
            }, {
                mergeCell: `CB${this.startPosition + 1}:CH${this.startPosition + 1}`,
                name: "Allotments Received",
                cell: `CH${this.startPosition + 1}`
            }, {
                mergeCell: `CI${this.startPosition + 1}:CO${this.startPosition + 1}`,
                name: "Adjustments (Reduction, Modification) PRE",
                cell: `CO${this.startPosition + 1}`
            }, {
                mergeCell: `CP${this.startPosition + 1}:CV${this.startPosition + 1}`,
                name: "Adjustments (Reduction, Modification) SB",
                cell: `CV${this.startPosition + 1}`
            }, {
                mergeCell: `CW${this.startPosition + 1}:DC${this.startPosition + 1}`,
                name: "Adjustments (Reduction, Modification)",
                cell: `DC${this.startPosition + 1}`
            }, {
                mergeCell: `DD${this.startPosition + 1}:DJ${this.startPosition + 1}`,
                name: "Adjusted Allotment Received PRE",
                cell: `DJ${this.startPosition + 1}`
            }, {
                mergeCell: `DK${this.startPosition + 1}:DQ${this.startPosition + 1}`,
                name: "Adjusted Allotment Received SB",
                cell: `DQ${this.startPosition + 1}`
            }, {
                mergeCell: `DR${this.startPosition + 1}:DX${this.startPosition + 1}`,
                name: "Adjusted Allotment Received",
                cell: `DX${this.startPosition + 1}`
            }, {
                mergeCell: `DY${this.startPosition}:ES${this.startPosition}`,
                name: "Utilizations",
                cell: `ES${this.startPosition}`
            }, {
                mergeCell: `DY${this.startPosition + 1}:EE${this.startPosition + 1}`,
                name: "Utilizations PRE",
                cell: `EE${this.startPosition + 1}`
            }, {
                mergeCell: `EF${this.startPosition + 1}:EL${this.startPosition + 1}`,
                name: "Utilizations SB",
                cell: `EL${this.startPosition + 1}`
            }, {
                mergeCell: `EM${this.startPosition + 1}:ES${this.startPosition + 1}`,
                name: "Utilizations",
                cell: `ES${this.startPosition + 1}`
            }, {
                mergeCell: `ET${this.startPosition}:GI${this.startPosition}`,
                name: "Balances",
                cell: `GI${this.startPosition}`
            }, {
                mergeCell: `ET${this.startPosition + 1}:EZ${this.startPosition + 1}`,
                name: "Unobligated Balance PRE",
                cell: `EZ${this.startPosition + 1}`
            }, {
                mergeCell: `FA${this.startPosition + 1}:FG${this.startPosition + 1}`,
                name: "UnobligatedBalance SB",
                cell: `FG${this.startPosition + 1}`
            }, {
                mergeCell: `FH${this.startPosition + 1}:FN${this.startPosition + 1}`,
                name: "Unobligated Balance",
                cell: `FN${this.startPosition + 1}`
            }, {
                mergeCell: `FO${this.startPosition + 1}:FU${this.startPosition + 1}`,
                name: "Unreleased Approved Budget PRE",
                cell: `FU${this.startPosition + 1}`
            }, {
                mergeCell: `FV${this.startPosition + 1}:GB${this.startPosition + 1}`,
                name: "Unreleased Approved Budget SB",
                cell: `GB${this.startPosition + 1}`
            }, {
                mergeCell: `GC${this.startPosition + 1}:GI${this.startPosition + 1}`,
                name: "Unreleased Approved Budget",
                cell: `GI${this.startPosition + 1}`
            }, {
                mergeCell: `GJ${this.startPosition}:HD${this.startPosition}`,
                name: "Disbursement",
                cell: `HD${this.startPosition}`
            }, {
                mergeCell: `GJ${this.startPosition + 1}:GP${this.startPosition + 1}`,
                name: "Disbursement PRE",
                cell: `GP${this.startPosition + 1}`
            }, {
                mergeCell: `GQ${this.startPosition + 1}:GW${this.startPosition + 1}`,
                name: "Disbursement SB",
                cell: `GW${this.startPosition + 1}`
            }, {
                mergeCell: `GX${this.startPosition + 1}:HD${this.startPosition + 1}`,
                name: "Disbursement",
                cell: `HD${this.startPosition + 1}`
            }, {
                mergeCell: `HE${this.startPosition}:IT${this.startPosition}`,
                name: "Unpaid Balance",
                cell: `IT${this.startPosition}`
            }, {
                mergeCell: `HE${this.startPosition + 1}:HK${this.startPosition + 1}`,
                name: "Due and Demandable PRE",
                cell: `HK${this.startPosition + 1}`
            }, {
                mergeCell: `HL${this.startPosition + 1}:HR${this.startPosition + 1}`,
                name: "Due and Demandable SB",
                cell: `HR${this.startPosition + 1}`
            }, {
                mergeCell: `HS${this.startPosition + 1}:HY${this.startPosition + 1}`,
                name: "Due and Demandable",
                cell: `HY${this.startPosition + 1}`
            }, {
                mergeCell: `HZ${this.startPosition + 1}:IF${this.startPosition + 1}`,
                name: "Not Yet Due and Demandable PRE",
                cell: `IF${this.startPosition + 1}`
            }, {
                mergeCell: `IG${this.startPosition + 1}:IM${this.startPosition + 1}`,
                name: "Not Yet Due and Demandable SB",
                cell: `IM${this.startPosition + 1}`
            }, {
                mergeCell: `IN${this.startPosition + 1}:IT${this.startPosition + 1}`,
                name: "Not Yet Due and Demandable",
                cell: `IT${this.startPosition + 1}`
            }
        ];

        cells.forEach((c: any) => {
            ws.mergeCells(c.mergeCell);
            let cell = ws.getCell(c.cell);
            cell.value = c.name;
            cell.font = this.fontStyle.header;
            cell.border = this.borderStyle.full;
            cell.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };
        });

        let details = [
            { name: "Central Admin" },
            { name: "BatStateU-Pablo Borbon" },
            { name: "BatStateU-Alangilan" },
            { name: "BatStateU-Lipa" },
            { name: "BatStateU-Malvar JPLPC" },
            { name: "BatStateU-Nasugbu ARASOF" },
            { name: "Total" }
        ];

        for (let i = 2; i < this.detailed_columns.length; i += 7) {
            details.forEach((d: any, index: number) => {
                let cell = ws.getCell(`${this.detailed_columns[i + index]}${this.startPosition + 2}`);
                cell.value = d.name;
                cell.font = this.fontStyle.header;
                cell.border = this.borderStyle.full;
                cell.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };
            });
        }

        ws.getRow(this.startPosition + 2).height = 40;

    }

    private setSummaryHeader(ws: ExcelJS.Worksheet) {

        let cells = [
            {
                mergeCell: `A${this.startPosition}:A${this.startPosition + 1}`,
                name: "Particulars",
                cell: `A${this.startPosition + 1}`
            }, {
                mergeCell: `B${this.startPosition}:B${this.startPosition + 1}`,
                name: "UACS Code",
                cell: `B${this.startPosition + 1}`
            }, {
                mergeCell: `C${this.startPosition}:K${this.startPosition}`,
                name: "Approved Budget",
                cell: `K${this.startPosition}`
            }, {
                mergeCell: `C${this.startPosition + 1}:C${this.startPosition + 1}`,
                name: "PRE",
                cell: `C${this.startPosition + 1}`
            }, {
                mergeCell: `D${this.startPosition + 1}:D${this.startPosition + 1}`,
                name: "SB",
                cell: `D${this.startPosition + 1}`
            }, {
                mergeCell: `E${this.startPosition + 1}:E${this.startPosition + 1}`,
                name: "Approved Budget",
                cell: `E${this.startPosition + 1}`
            }, {
                mergeCell: `F${this.startPosition + 1}:F${this.startPosition + 1}`,
                name: "PRE",
                cell: `F${this.startPosition + 1}`
            }, {
                mergeCell: `G${this.startPosition + 1}:G${this.startPosition + 1}`,
                name: "SB",
                cell: `G${this.startPosition + 1}`
            }, {
                mergeCell: `H${this.startPosition + 1}:H${this.startPosition + 1}`,
                name: "Adjustments",
                cell: `H${this.startPosition + 1}`
            }, {
                mergeCell: `I${this.startPosition + 1}:I${this.startPosition + 1}`,
                name: "PRE",
                cell: `I${this.startPosition + 1}`
            }, {
                mergeCell: `J${this.startPosition + 1}:J${this.startPosition + 1}`,
                name: "SB",
                cell: `J${this.startPosition + 1}`
            }, {
                mergeCell: `K${this.startPosition + 1}:K${this.startPosition + 1}`,
                name: "Adjusted Approved Budget",
                cell: `K${this.startPosition + 1}`
            }, {
                mergeCell: `L${this.startPosition}:T${this.startPosition}`,
                name: "Allotments",
                cell: `T${this.startPosition}`
            }, {
                mergeCell: `L${this.startPosition + 1}:L${this.startPosition + 1}`,
                name: "PRE",
                cell: `L${this.startPosition + 1}`
            }, {
                mergeCell: `M${this.startPosition + 1}:M${this.startPosition + 1}`,
                name: "SB",
                cell: `M${this.startPosition + 1}`
            }, {
                mergeCell: `N${this.startPosition + 1}:N${this.startPosition + 1}`,
                name: "Allotments Received",
                cell: `N${this.startPosition + 1}`
            }, {
                mergeCell: `O${this.startPosition + 1}:O${this.startPosition + 1}`,
                name: "PRE",
                cell: `O${this.startPosition + 1}`
            }, {
                mergeCell: `P${this.startPosition + 1}:P${this.startPosition + 1}`,
                name: "SB",
                cell: `P${this.startPosition + 1}`
            }, {
                mergeCell: `Q${this.startPosition + 1}:Q${this.startPosition + 1}`,
                name: "Adjustments (Reduction, Modification)",
                cell: `Q${this.startPosition + 1}`
            }, {
                mergeCell: `R${this.startPosition + 1}:R${this.startPosition + 1}`,
                name: "PRE",
                cell: `R${this.startPosition + 1}`
            }, {
                mergeCell: `S${this.startPosition + 1}:S${this.startPosition + 1}`,
                name: "SB",
                cell: `S${this.startPosition + 1}`
            }, {
                mergeCell: `T${this.startPosition + 1}:T${this.startPosition + 1}`,
                name: "Adjusted Allotment Received",
                cell: `T${this.startPosition + 1}`
            }, {
                mergeCell: `U${this.startPosition}:W${this.startPosition}`,
                name: "Utilizations",
                cell: `W${this.startPosition}`
            }, {
                mergeCell: `U${this.startPosition + 1}:U${this.startPosition + 1}`,
                name: "PRE",
                cell: `U${this.startPosition + 1}`
            }, {
                mergeCell: `V${this.startPosition + 1}:V${this.startPosition + 1}`,
                name: "SB",
                cell: `V${this.startPosition + 1}`
            }, {
                mergeCell: `W${this.startPosition + 1}:W${this.startPosition + 1}`,
                name: "Utilizations",
                cell: `W${this.startPosition + 1}`
            }, {
                mergeCell: `X${this.startPosition}:AC${this.startPosition}`,
                name: "Balances",
                cell: `AC${this.startPosition}`
            }, {
                mergeCell: `X${this.startPosition + 1}:X${this.startPosition + 1}`,
                name: "PRE",
                cell: `X${this.startPosition + 1}`
            }, {
                mergeCell: `Y${this.startPosition + 1}:Y${this.startPosition + 1}`,
                name: "SB",
                cell: `Y${this.startPosition + 1}`
            }, {
                mergeCell: `Z${this.startPosition + 1}:Z${this.startPosition + 1}`,
                name: "Unobligated Balance",
                cell: `Z${this.startPosition + 1}`
            }, {
                mergeCell: `AA${this.startPosition + 1}:AA${this.startPosition + 1}`,
                name: "PRE",
                cell: `AA${this.startPosition + 1}`
            }, {
                mergeCell: `AB${this.startPosition + 1}:AB${this.startPosition + 1}`,
                name: "SB",
                cell: `AB${this.startPosition + 1}`
            }, {
                mergeCell: `AC${this.startPosition + 1}:AC${this.startPosition + 1}`,
                name: "Unreleased Approved Budget",
                cell: `AC${this.startPosition + 1}`
            }, {
                mergeCell: `AD${this.startPosition}:AF${this.startPosition}`,
                name: "Disbursement",
                cell: `AF${this.startPosition}`
            }, {
                mergeCell: `AD${this.startPosition + 1}:AD${this.startPosition + 1}`,
                name: "PRE",
                cell: `AD${this.startPosition + 1}`
            }, {
                mergeCell: `AE${this.startPosition + 1}:AE${this.startPosition + 1}`,
                name: "SB",
                cell: `AE${this.startPosition + 1}`
            }, {
                mergeCell: `AF${this.startPosition + 1}:AF${this.startPosition + 1}`,
                name: "Disbursement",
                cell: `AF${this.startPosition + 1}`
            }, {
                mergeCell: `AG${this.startPosition}:AL${this.startPosition}`,
                name: "Unpaid Balance",
                cell: `AL${this.startPosition}`
            }, {
                mergeCell: `AG${this.startPosition + 1}:AG${this.startPosition + 1}`,
                name: "PRE",
                cell: `AG${this.startPosition + 1}`
            }, {
                mergeCell: `AH${this.startPosition + 1}:AH${this.startPosition + 1}`,
                name: "SB",
                cell: `AH${this.startPosition + 1}`
            }, {
                mergeCell: `AI${this.startPosition + 1}:AI${this.startPosition + 1}`,
                name: "Due and Demandable",
                cell: `AI${this.startPosition + 1}`
            }, {
                mergeCell: `AJ${this.startPosition + 1}:AJ${this.startPosition + 1}`,
                name: "PRE",
                cell: `AJ${this.startPosition + 1}`
            }, {
                mergeCell: `AK${this.startPosition + 1}:AK${this.startPosition + 1}`,
                name: "SB",
                cell: `AK${this.startPosition + 1}`
            }, {
                mergeCell: `AL${this.startPosition + 1}:AL${this.startPosition + 1}`,
                name: "Not Yet Due and Demandable",
                cell: `AL${this.startPosition + 1}`
            }
        ];

        cells.forEach((c: any) => {
            ws.mergeCells(c.mergeCell);
            let cell = ws.getCell(c.cell);
            cell.value = c.name;
            cell.font = this.fontStyle.header;
            cell.border = this.borderStyle.full;
            cell.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };
        });

        let formula = [
            "(1)", "(2)",
            "(3)", "(4)", "(5=3+4)",
            "(6)", "(7)", "(8=6+7)",
            "(9=3+6)", "(10=4+7)", "(11=9+10)",
            "(12)", "(13)", "(14=12+13)",
            "(15)", "(16)", "(17=15+16)",
            "(18=12+15)", "(19=13+16)", "(20=18+19)",
            "(21)", "(22)", "(23=21+22)",
            "(24=18-21)", "(25=19-22)", "(26=24+25)", "(27=9-12)", "(28=10-13)", "(29=27+28)",
            "(30)", "(31)", "(32=30+31)",
            "(33=21-30)", "(34=22-31)", "(35=33+34)",
            "(36=21-30-33)", "(37=22-31-34)", "(38=36+37)"
        ];

        for (let i = 0; i < this.summary_columns.length; i++) {
            let cell = ws.getCell(`${this.detailed_columns[i]}${this.startPosition + 2}`);
            cell.value = formula[i];
            cell.font = this.fontStyle.header;
            cell.border = this.borderStyle.full;
            cell.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };
        }

    }

    private getNumber(item: any) {
        if (item.uacs == null || item.ac == null || item.uacs.substring(3) == "0000000") {
            const index = this.aIndex;

            // I-1.1, I-1.2, II-1.1, II-1.2
            if (item.ac != null && item.uacs.substring(3) == "0000000") {
                this.cIndex++;
                return `${this.fundSourceIndex}.${this.cIndex} `;
            }

            // I-1, I-2, II-1, II-2
            if (item.uacs == '0000000000') {
                this.cIndex = 0;
                this.fundSourceIndex = `${this.romanIndex}-${this.bIndex}`;
                this.bIndex++;
                return `${this.fundSourceIndex} `;
            }

            // I, II
            if (item.f_code.substring(5) == "0000") {
                this.romanIndex = this.romanNumber[index];
                this.bIndex = 1;

                this.aIndex++;
                if (this.aIndex > 1) {
                    this.aIndex = 0;
                }

                return `${this.romanIndex}. `;
            }

            if (item.f_code.substring(5) == "9999" && item.f_code != "999999999") {
                return `${this.romanIndex}. `;
            }
        }
        return "";
    }

    private indention(item: any) {
        let result = false;
        if (item.uacs != null) {
            if (item.uacs.substring(3) != "0000000") {
                result = true;
            }
        }
        return result;
    }

    private coalesce(value1: any, value2: any) {
        if (value1 == null || (this.numService.isNumber(value1) && value1 == 0) || value1 == "") {
            return value2;
        }
        return value1;
    }

}